import AddIcon from "@mui/icons-material/Add";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";
import SaveIcon from "@mui/icons-material/Save";
import { Card, Grid, Typography } from "@mui/material";
import { groupBy, uniq, uniqBy } from "lodash";
import moment from "moment";
import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import Custom3dotString from "../../../../components/Custom3dotString";
import CustomButton from "../../../../components/CustomButton";
import CustomCheckbox from "../../../../components/CustomCheckbox";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../../components/CustomTextField";
import CustomUpload from "../../../../components/CustomUpload";
import CustomSelect from "../../../../components/Select/Select";
import { soapApi } from "../../../../redux/actions/api";
import {
  enableCheckoutByAppointmentId,
  getClinicFacilities,
  getLocations,
} from "../../../../redux/reducers/clinicSlice";
import { hideLoader, showLoader } from "../../../../redux/reducers/loaderSlice";
import {
  createPrescriptionWoLoader,
  createProcedure,
  createProcedureWoLoader,
  deletePrescriptionItemByIdWoLoader,
  deleteProcedureByIdWoLoader,
  deleteProcedureDetailByIdWoLoader,
  getPetsCompliantSummaryWoLoader,
  updateNoteByAppointmentIdWoLoader,
  updatePrescriptionByIdWoLoader,
  updateProcedureByIdWoLoader,
} from "../../../../redux/reducers/petSlice";
import { AppColors } from "../../../../util/AppColors";
import { frequncyCheckList, reasonList } from "../../../../util/arrayList";
import { a4PrintConfig } from "../../../../util/commonConfig";
import {
  mealTypes,
  radioYesNoList,
  routeList,
  statusDrop,
} from "../../../../util/dropList";
import { billingTabEnum, genderEnum } from "../../../../util/enum";
import {
  datePlusOneDay,
  getFeedingFrequency,
  getOnlyName,
  getProcedureDetailsNew,
  getRightPackageUom,
  getRightSaluation,
} from "../../../../util/function";
import ContentToPrint from "../../../CommonScreens/ContentToPrint/ContentToPrint";
import PrescriptionView from "../../../CommonScreens/WorkBook/PrescriptionView";
import FilesWithCloseButton from "./FilesWithCloseButton";

/** Applied in the print iframe (react-to-print); forces A4 when saving as PDF from the print dialog. */

const initProced = { consumList: [], adminList: [], presList: [] };
const addIcon = { color: AppColors.appPrimary, width: 15, height: 15 };
const delBtn = { color: AppColors.red, width: 20, height: 20 };
const edtBtn = { color: AppColors.appPrimary, width: 20, height: 20 };
const initOpenObj = { consum: true, admin: true, pres: true };
const cardSty = {
  borderRadius: 3,
  padding: 1,
  borderTopColor: AppColors.appPrimary,
  marginLeft: 0.5,
  marginRight: 0.5,
  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.25)",
};
const cardIcon = { width: 30, height: 30, color: AppColors.appPrimary };
const reqTxt = "This field is required";
const initPres = {
  name: null,
  dosage: "1",
  duration: "1",
  frequency: [],
  meal: "",
  customFrequency: false,
  route: routeList?.[0],
  plName: null,
};
const initFileValues = { modVsble: false, files: [], type: null };

const PetProcedures = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const contentToPrint = useRef(null);
  const printTitleRef = useRef("");
  const locationsAndFacilitiesFetchedRef = useRef(false);
  const [procedures, setProcedures] = useState([]);
  const [selectedProcedure, setSelectedProcedure] = useState(null);
  const [procedValues, setProcedValues] = useState(initProced);
  const [changeWarnVsble, setChangeWarnVsble] = useState(false);
  const [notesModVsble, setNotesModVsble] = useState(false);
  const [notes, setNotes] = useState("");
  const [adminValues, setAdminValues] = useState({});
  const [consumValues, setConsumValues] = useState({});
  const [admStatusVsble, setAdmStatusVsble] = useState(false);
  const [admUpdteModVsble, setAdmUpdteModVsble] = useState(false);
  const [conStatusVsble, setConStatusVsble] = useState(false);
  const [fileValues, setFileValues] = useState(initFileValues);
  const [objOpen, setObjOpen] = useState(initOpenObj);
  const [selectedItem, setSelectedItem] = useState(null);
  const [delModVsble, setDelModVsble] = useState(false);
  const [previewModVsble, setPreviewModVsble] = useState(false);
  const [addProcedModVsble, setAddProcedModVsble] = useState(false);
  const [addNewProcedValues, setAddNewProcedValues] = useState({});
  const {
    services: serviceList,
    clinicStocks: stockList,
    petBilling,
    locationList,
    facilities,
    selectedClinicBranch,
    details: clinicDetails,
  } = useSelector((state) => state?.clinic);
  const { appointment } = location.state || {};
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const appDet = reqDet?.appointment;
  const role = localStorage.getItem("role");
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const {
    clinic: clinicDataDet,
    vets: clinicVets,
    services: clinicServices,
    stocks: clinicStockList,
  } = useMemo(() => {
    if (!mandateDataRaw) {
      return { clinic: {}, vets: [], services: [], stocks: [] };
    }
    try {
      const reqData = JSON.parse(mandateDataRaw);
      return {
        clinic: reqData?.clinic ?? {},
        vets: Array.isArray(reqData?.vets) ? reqData?.vets : [],
        services: Array.isArray(reqData?.services) ? reqData?.services : [],
        stocks: Array.isArray(reqData?.stocks) ? reqData?.stocks : [],
      };
    } catch {
      return { clinic: {}, vets: [], services: [], stocks: [] };
    }
  }, [mandateDataRaw]);
  const services =
    role === "ROLE_DOCTOR" && selectedClinicBranch?.branchId
      ? // appDet?.hospitalId !== clinicDet?.id
        (serviceList?.data ?? [])
      : (clinicServices ?? []);
  const clinicStocks =
    role === "ROLE_DOCTOR" && selectedClinicBranch?.branchId
      ? // appDet?.hospitalId !== clinicDet?.id
        (stockList?.data ?? [])
      : (clinicStockList ?? []);
  const clinicDet = clinicDataDet?.id ? clinicDataDet : clinicDetails;

  useEffect(() => {
    if (locationsAndFacilitiesFetchedRef.current) return;
    if (role === "ROLE_DOCTOR") {
      if (!selectedClinicBranch?.branchId) return;
      locationsAndFacilitiesFetchedRef.current = true;
      dispatch(getLocations(`?clinicId=${selectedClinicBranch?.branchId}`));
      dispatch(
        getClinicFacilities(`?clinicId=${selectedClinicBranch?.branchId}`),
      );
      return;
    }
  }, [selectedClinicBranch, role, dispatch]);

  useEffect(() => {
    if (!reqDet) {
      setProcedures([]);
      setProcedValues({ ...initProced });
      return;
    }

    const safeServices = Array.isArray(services) ? services : [];
    const safeStocks = Array.isArray(clinicStocks) ? clinicStocks : [];

    const normName = (v) =>
      typeof v === "string" ? v?.trim()?.toLowerCase() : "";
    const resolveProcedureVariant = (prcd, vnts) => {
      if (!vnts?.length) return null;
      const byLabel = vnts?.find(
        (vnt) =>
          vnt?.serviceId === prcd?.serviceId &&
          normName(vnt?.name) === normName(prcd?.serviceType),
      );
      if (byLabel) return byLabel;
      const procVariantId =
        prcd?.variantId ?? prcd?.procedureVariantId ?? prcd?.procedureVariantID;
      if (procVariantId != null) {
        const byId = vnts.find(
          (vnt) =>
            vnt?.variantId != null &&
            String(vnt?.variantId) === String(procVariantId),
        );
        if (byId) return byId;
      }
      return vnts[0] ?? null;
    };

    const reqPrceds = [];
    const reqCons = [];
    const reqAdms = [];
    const reqPresList = [];
    const rawProcedures = reqDet?.procedures;
    const reqProcedList = [
      ...(Array.isArray(rawProcedures) ? rawProcedures : []),
    ].sort((a, b) => {
      const aid = Number(a?.procedureId);
      const bid = Number(b?.procedureId);
      return (
        (Number.isFinite(aid) ? aid : 0) - (Number.isFinite(bid) ? bid : 0)
      );
    });
    reqProcedList?.forEach((prcd, i) => {
      const reqServ = safeServices.find(
        (ser) => ser?.serviceId === prcd?.serviceId,
      );
      const vnts = getVarinatList(prcd?.serviceId, safeServices);
      const reqVnt = resolveProcedureVariant(prcd, vnts);
      const reqObj = {
        service: {
          name: reqServ?.serviceName,
          value: reqServ?.serviceName,
          serviceId: reqServ?.serviceId,
          category: reqServ?.category,
          subCategory: reqServ?.subCategory,
          remarks: reqServ?.description,
          procedureId: prcd?.procedureId,
        },
        variant: reqVnt,
        procedureId: prcd?.procedureId,
        quantity: prcd?.quantity ?? 1,
        i,
      };
      reqPrceds.push(reqObj);
      const resolvedVariantId =
        reqVnt?.variantId ??
        prcd?.variantId ??
        prcd?.procedureVariantId ??
        prcd?.procedureVariantID;
      const rawDetails = prcd?.procedureDetails;
      const reqProcedDetList = [
        ...(Array.isArray(rawDetails) ? rawDetails : []),
      ]?.sort((a, b) => {
        const ad = Number(a?.detailId);
        const bd = Number(b?.detailId);
        return (Number.isFinite(ad) ? ad : 0) - (Number.isFinite(bd) ? bd : 0);
      });
      reqProcedDetList?.forEach((det) => {
        const reqStock = safeStocks.find(
          (stc) => stc?.stockId === det?.stockId,
        );
        const batches = reqStock?.stockBatch;
        const reqBatc = Array.isArray(batches)
          ? batches.find((bat) => bat?.batchId === det?.batchId)
          : undefined;
        const comObj = {
          name: det?.name ?? reqStock?.productName ?? det?.procedureName ?? "",
          procedureName: det?.procedureName,
          stockId: det?.stockId,
          batchId: det?.batchId,
          quantity: det?.quantity,
          detailId: det?.detailId,
          active: det?.active,
          isRejected: det?.status === "rejected",
          isRequested: det?.status === "requested",
          isIssued: det?.status === "issued",
          remarks: det?.remarks,
          status:
            det?.status?.length > 0
              ? det?.status === "true"
                ? true
                : det?.status === "false"
                  ? false
                  : null
              : null,
          statusDrop:
            det?.status?.length > 0
              ? det?.status === "true"
                ? statusDrop?.[0]
                : statusDrop?.[1]
              : null,
          reason: det?.remarks?.length > 0 ? det?.remarks : null,
          estCost: det?.estimatedCost,
          delete: false,
          isEdit:
            det?.status === "true" ||
            det?.status === "false" ||
            det?.status === "requested" ||
            det?.status === "rejected"
              ? false
              : true,
          deleteable: true,
          serviceId: prcd?.serviceId,
          variantId: resolvedVariantId,
          assignToProcedure: {
            name: reqServ?.serviceName,
            serviceId: prcd?.serviceId,
            value: reqServ?.serviceName,
            variantId: resolvedVariantId,
          },
          linkToProcedure:
            det?.linked === "N"
              ? null
              : {
                  name: reqServ?.serviceName,
                  value: reqServ?.serviceName,
                  serviceId: prcd?.serviceId,
                  varinatName: reqVnt?.name,
                  variantId: resolvedVariantId,
                },
          batchNumber: reqStock?.autoConsumed
            ? //null
              { name: "-", value: null, batchId: null, salesUom: null }
            : {
                name: reqBatc?.batchNo ?? "Unknown",
                value: reqBatc?.batchId ?? null,
                batchId: reqBatc?.batchId ?? null,
                salesUom: reqBatc?.salesUom ?? null,
              },
        };
        if (det?.type === "Consumables") {
          reqCons.push(comObj);
        }
        if (det?.type === "Administered") {
          const reqAdmObj = {
            ...comObj,
            type: reqStock?.category,
            route: routeList?.find((rl) => rl?.name === det?.route) ?? null,
            duration: "1",
            vaccineType: det?.route,
            dosage: det?.dosage,
          };
          reqAdms.push(reqAdmObj);
        }
      });
    });
    const prescDetails = reqDet?.prescription?.[0]?.prescriptionDetails;
    const reqPresDetList = [
      ...(Array.isArray(prescDetails) ? prescDetails : []),
    ]?.sort((a, b) => {
      const ai = Number(a?.id);
      const bi = Number(b?.id);
      return (Number.isFinite(ai) ? ai : 0) - (Number.isFinite(bi) ? bi : 0);
    });
    reqPresDetList?.forEach((li, i) => {
      const reqObj = {
        ...li,
        detailId: li?.id,
        name: null,
        dosage: li?.dosage,
        duration: li?.duration,
        // frequency:
        //   li?.morning || li?.afternoon || li?.night
        //     ? [
        //         li?.morning && "morning",
        //         li?.afternoon && "afternoon",
        //         li?.night && "night",
        //       ]?.filter(Boolean)
        //     : li?.frequencyDuration?.length > 0
        //       ? li?.frequencyDuration
        //       : null,
        // customFrequency:
        //   !li?.morning &&
        //   !li?.afternoon &&
        //   !li?.night &&
        //   li?.frequencyDuration?.length > 0,
        meal: li?.meal,
        plName: li?.name,
        i,
        type: li?.type,
        stockId: li?.stockId,
        qty: li?.quantity,
        isEdit: false,
        route: routeList?.find((rl) => rl?.name === li?.route) ?? null,
      };
      if (
        Array.isArray(li?.frequencyDuration) &&
        li.frequencyDuration.length > 0
      ) {
        const reqList = li.frequencyDuration
          .map((freq) => frequncyCheckList?.find((f) => f?.apiValue === freq))
          ?.filter(Boolean);
        reqObj.frequency = reqList;
      }
      reqPresList.push(reqObj);
    });
    setProcedures(reqPrceds);
    const reqConsList =
      reqCons?.length > 0
        ? reqCons
            ?.sort((a, b) => {
              const ad = Number(a?.detailId);
              const bd = Number(b?.detailId);
              return (
                (Number.isFinite(ad) ? ad : 0) - (Number.isFinite(bd) ? bd : 0)
              );
            })
            ?.map((cl, i) => ({ ...cl, i }))
        : [];
    const reqAdmList =
      reqAdms?.length > 0
        ? reqAdms
            ?.sort((a, b) => {
              const ad = Number(a?.detailId);
              const bd = Number(b?.detailId);
              return (
                (Number.isFinite(ad) ? ad : 0) - (Number.isFinite(bd) ? bd : 0)
              );
            })
            ?.map((al, i) => ({ ...al, i }))
        : [];
    const reqPrescpList =
      reqPresList?.length > 0
        ? reqPresList?.map((pl, i) => ({ ...pl, i }))
        : [];
    setProcedValues((prev) => {
      const next = {
        ...prev,
        consumList: reqConsList,
        adminList: reqAdmList,
        presList: reqPrescpList,
      };
      if (reqPresList?.length > 0) {
        next.presNotesVisible =
          (reqDet?.prescription?.[0]?.remark ?? "")?.length > 0;
        next.notes = reqDet?.prescription?.[0]?.remark ?? "";
        next.isNotesEdit = false;
      }
      return next;
    });
  }, [reqDet, appDet?.appointmentId, services, clinicStocks]);

  const onApiCall = () => {
    dispatch(getPetsCompliantSummaryWoLoader(appDet?.appointmentId));
  };

  const getReqFacility = () => {
    return (
      facilities?.find((fac) => fac?.facilityId === appDet?.facilityId) ?? null
    );
  };

  const getVetDepartment = () => {
    const reqDept =
      clinicVets?.find((vl) => vl?.doctorId === appDet?.doctorId)?.department ??
      null;
    return reqDept;
  };

  const getBatchList = (stockId = null) => {
    if (!stockId) return [];
    const reqStock = clinicStocks?.find((stc) => stc?.stockId === stockId);
    if (!reqStock) return [];
    const filteredBatches = reqStock?.stockBatch
      // ?.filter((btch) => btch?.billlable === "Y")
      ?.map((btch) => ({
        name: btch?.batchNo,
        value: btch?.batchNo,
        batchId: btch?.batchId,
        salesUom: btch?.salesUom,
        packageUom: btch?.packageUom,
      }));
    return filteredBatches;
  };

  const getBatch = (stockId, batchId = null, retStock = false) => {
    if (!stockId) return null;
    const reqStock = clinicStocks?.find((stc) => stc?.stockId === stockId);
    if (retStock) return reqStock;
    if (!batchId) return null;
    return (
      reqStock?.stockBatch?.find((bat) => bat?.batchId === batchId) ?? null
    );
  };

  const getServiceList = () => {
    const reqServList = services
      ?.filter(
        (sl) =>
          sl?.active === "Y" &&
          !["lab", "radiology"].includes(sl?.category?.toLowerCase()),
      )
      ?.map((ser) => ({
        name: ser?.serviceName,
        value: ser?.serviceName,
        serviceId: ser?.serviceId,
        category: ser?.category,
        subCategory: ser?.subCategory,
        remarks: ser?.description,
      }));
    // const procedureIds = new Set(procedures?.map((p) => p?.service?.serviceId));
    // const reqList = reqServList?.filter(
    //   (srv) => !procedureIds.has(srv?.serviceId)
    // );
    return reqServList;
  };

  const onChange = (name, value, ind, vrntId) => {
    const reqPrcdres = procedures?.map((li) => {
      if (li?.i === ind) {
        const reqObj = { ...li, [name]: value };
        if (name === "service") {
          reqObj.serviceId = value?.serviceId;
          const vrnts = getVarinatList(value?.serviceId);
          reqObj.variant = vrnts?.[0];
          reqObj.variantId = vrnts?.[0]?.variantId;
        }
        if (name === "variant") {
          reqObj.variantId = value?.variantId;
        }
        return reqObj;
      }
      return li;
    });
    setProcedures(reqPrcdres);
  };

  const getVarinatList = (serId, serviceSource = null) => {
    if (serId == null || serId === "") return [];
    const src = Array.isArray(serviceSource)
      ? serviceSource
      : Array.isArray(services)
        ? services
        : [];
    const variants = src.find(
      (ser) => ser?.serviceId === serId,
    )?.serviceVariants;
    if (!Array.isArray(variants)) return [];
    return variants.map((vnt) => ({
      name: vnt?.variantName,
      variantId: vnt?.variantId,
      servicePrice: vnt?.servicePrice ?? 0,
      // servicePrice: vnt?.serviceCharge ?? 0,
      value: vnt?.variantName,
      serviceCharge: vnt?.serviceCharge,
      variantNumber: vnt?.variantNumber,
      serviceId: serId,
    }));
  };

  const onCloseDelMod = () => {
    setDelModVsble(false);
    setSelectedItem(null);
  };

  const deleteProcedureById = (id) => {
    dispatch(deleteProcedureByIdWoLoader(id)).then((res) => {
      if (res?.payload) {
        onCloseDelMod();
        onApiCall();
      }
    });
  };

  const delProcedure = (ind) => {
    const reqServ = procedures?.find((li) => li?.i === ind)?.service;
    if (reqServ?.procedureId) {
      const reqPrcdure = reqDet?.procedures?.find(
        (li) => li?.procedureId === reqServ?.procedureId,
      );
      if (
        reqPrcdure?.procedureDetails?.some((li) =>
          ["true", "false"].includes(li?.status),
        )
      ) {
        setSelectedProcedure({
          type: "delete",
          index: ind,
          serviceId: reqServ?.serviceId,
          procedureId: reqServ?.procedureId ?? null,
        });
        return setChangeWarnVsble(true);
      } else {
        setSelectedItem({ item: reqServ, type: "procedure" });
        setDelModVsble(true);
      }
    } else {
      const reqList = procedures
        ?.filter((li) => li?.i !== ind)
        ?.map((li, i) => ({ ...li, i }));
      setProcedures(reqList);
    }
  };

  const addPreventive = (itm) => {
    const reqSer = services?.find((li) => li?.serviceId === itm?.serviceId);
    const reqVnt = reqSer?.serviceVariants?.find(
      (li) => li?.variantId === itm?.variantId,
    );
    const data = {
      doneAt: moment(new Date(itm?.nextDueDate)).format("YYYY-MM-DD"),
      remarks: "",
      procedureDetails: [],
      serviceType: reqVnt?.variantName,
      isFromPreventive: true,
      procedureVariantId: reqVnt?.variantId ?? itm?.variantId,
      procedureName: itm?.linkToProcedure,
      serviceId: itm?.serviceId,
      category: reqSer?.category ?? "",
      subCategory: reqSer?.subCategory ?? "",
      petId: appDet?.petId,
      status: "Pending",
    };
    dispatch(createProcedure({ data }));
  };

  const onCloseFileMod = () => {
    setFileValues(initFileValues);
  };

  const getItemPrice = (stkId = null, batchId = null) => {
    let unitSellingPrice = 0;
    const reqStock = clinicStocks?.find((stc) => stc?.stockId === stkId);
    if (reqStock) {
      if (batchId) {
        return (
          reqStock?.stockBatch?.find((bat) => bat?.batchId === batchId)
            ?.unitSellingPrice ?? 0
        );
      }
      return reqStock?.stockBatch?.[0]?.unitSellingPrice;
    }
    return unitSellingPrice;
  };

  const addUpdateAdminItems = (obj) => {
    const reqProced = reqDet?.procedures?.find(
      (pl) => pl?.serviceId === obj?.serviceId,
    );
    if (!reqProced?.procedureId) return;
    const reqServ = services?.find((ser) => ser?.serviceId === obj?.serviceId);
    const reqVar = reqServ?.serviceVariants?.find(
      (vnt) =>
        vnt?.variantName?.toLowerCase() ===
        reqProced?.serviceType?.toLowerCase(),
    );
    const reqStock = clinicStocks?.find((stc) => stc?.stockId === obj?.stockId);
    const isNoAmount =
      reqStock?.autoConsumed || !reqStock?.billable || obj?.linkToProcedure;
    const reqBat = reqStock?.autoConsumed
      ? reqStock?.stockBatch?.[0]
      : obj?.batchId
        ? (reqStock?.stockBatch?.find((bat) => bat?.batchId === obj?.batchId) ??
          reqStock?.stockBatch?.[0])
        : reqStock?.stockBatch?.[0];
    const reqUnitPrice =
      reqBat?.unitSellingPrice ??
      reqStock?.stockBatch?.[0]?.unitSellingPrice ??
      0;
    const currLocat = locationList?.find(
      (loc) => loc?.id === reqBat?.locationId,
    );
    const taxPerent =
      reqServ?.taxApplicability?.toLowerCase() === "yes"
        ? Number(reqBat?.cgst ?? 0) + Number(reqBat?.sgst ?? 0)
        : 0;
    const reqPercent = 100 + Number(taxPerent);
    // const reqPack = reqBat?.packageUom?.match(/^(\d+)(.+)/);
    // const priceRatio = Number(obj?.dosage ?? 1) / Number(reqPack?.[1]);
    const reqPrice = (Number(reqUnitPrice) ?? 0) * Number(obj?.quantity ?? 0);
    const unitPrice = Number(reqPrice) / (reqPercent / 100);
    const priceAfterDiscount = Number(unitPrice);
    const prdTaxValue = (taxPerent / 100) * Number(priceAfterDiscount);
    const reqObj = {
      detailId: obj?.detailId ?? null,
      stockId: obj?.stockId ?? null,
      batchId:
        obj?.batchId ??
        obj?.batchNumber?.value ??
        (reqStock?.autoConsumed ? reqBat?.batchId : null),
      type: "Administered",
      quantity: Number(obj?.quantity ?? 1),
      status: reqStock?.autoConsumed
        ? obj?.detailId
          ? obj?.status
          : true
        : (obj?.batchId ?? obj?.batchNumber?.value)
          ? obj?.status
          : "requested",
      remarks: obj?.reason,
      estimatedCost: isNoAmount ? 0 : (reqPrice ?? obj?.estCost ?? 0),
      name: obj?.name,
      procedureName: obj?.name,
      dosage: obj?.dosage,
      route: obj?.route?.value ?? null,
      isDelete: false,
      serviceId: obj?.serviceId,
      itemIssued: obj?.itemIssued,
      itemIssuedStatus: obj?.itemIssuedStatus,
      tax: isNoAmount ? 0 : Number(prdTaxValue ?? 0),
      total: isNoAmount ? 0 : Number(reqPrice ?? 0),
      mrpPrice: isNoAmount ? 0 : Number(reqUnitPrice ?? 0),
      procedureVariantId:
        obj?.assignToProcedure?.variantId ??
        obj?.variantId ??
        reqVar?.variantId,
      patientWorkbook: true,
      mainProcedure: false,
      drugSchedule: reqServ?.drugSchedule ?? null,
      hsnSacCode: reqServ?.hsnSacCode ?? null,
      packageUom: reqBat?.salesUom ?? null,
      expiryDate: reqBat?.expiryDate ?? null,
      batchNo: reqBat?.batchNo ?? null,
      billable: reqStock?.billable,
      autoConsumed: reqStock?.autoConsumed,
      linked: !obj?.linkToProcedure ? "N" : null,
      billType: currLocat?.category
        ? billingTabEnum?.[currLocat?.category]
        : null,
    };
    // if (
    //   obj?.nextDosage === "Yes" &&
    //   obj?.status &&
    //   (obj?.type?.toLowerCase() === "flea & tick treatment" ||
    //     obj?.type?.toLowerCase() === "vaccines" ||
    //     obj?.type?.toLowerCase() === "deworming")
    // ) {
    //   addPreventive(obj);
    // }
    let tax = 0;
    let total = reqVar?.serviceCharge ?? reqProced?.serviceCharge ?? 0;
    if (reqServ?.taxApplicability?.toLowerCase() === "yes") {
      tax +=
        reqServ?.taxApplicability?.toLowerCase() === "yes"
          ? (Number(reqVar?.serviceCharge ?? reqProced?.serviceCharge ?? 0) /
              100) *
            Number(reqServ?.tax ?? 0)
          : 0;
      total += tax;
    }
    dispatch(
      updateProcedureByIdWoLoader({
        id: reqProced?.procedureId,
        data: {
          serviceCharge: reqProced?.serviceCharge,
          serviceType: reqProced?.serviceType,
          appointmentId: reqDet?.appointment?.appointmentId,
          procedureDetails: [reqObj],
          tax,
          total,
          mrpPrice: Number(reqVar?.serviceCharge ?? 0),
          procedureVariantId:
            obj?.variantId ??
            obj?.assignToProcedure?.variantId ??
            reqVar?.variantId,
          quantity: 1,
          hsnSacCode: reqServ?.hsnSacCode ?? null,
        },
      }),
    ).then((res) => {
      if (res?.payload) {
        onApiCall();
        onCloseFileMod();
      }
    });
    updateCheckoutStatus();
  };

  const handleEditProcedure = (ind) => {
    const reqList = procedures?.map((li, i) => {
      if (i === ind) {
        return {
          ...li,
          editable: true,
          prevServId: li?.service?.serviceId,
          prevVarntId: li?.variant?.variantId,
          procedureId: li?.procedureId ?? li?.service?.procedureId ?? null,
        };
      }
      return li;
    });
    setProcedures(reqList);
  };

  const onAddNotes = () => {
    setNotes(appDet?.notes ?? "");
    setNotesModVsble(true);
  };

  const handleAddNewPres = () => {
    const reqList = [
      ...procedValues?.presList,
      { ...initPres, i: procedValues?.presList?.length, isEdit: true },
    ];
    setProcedValues({ ...procedValues, presList: reqList });
  };

  const onChangePresValues = (name, value) => {
    const reqObj = { ...procedValues, [name]: value };
    if (name === "presNotesVisible" && value) {
      reqObj.isNotesEdit = true;
    }
    setProcedValues(reqObj);
  };

  const getRequiredBatch = (batchList = []) => {
    const primLocMat = batchList?.find(
      (bat) =>
        // bat?.billlable === "Y" &&
        bat?.locationId === getReqFacility()?.primaryStorage,
    );
    if (primLocMat) return primLocMat;
    const secLocMat = batchList?.find(
      (bat) =>
        // bat?.billlable === "Y" &&
        bat?.locationId === getReqFacility()?.secondaryStorage,
    );
    if (secLocMat) return secLocMat;
    if (role !== "ROLE_DOCTOR") {
      return batchList?.[0];
    }
    return {
      batchNo: "Unknown",
      batchId: null,
      name: "Unknown",
      value: null,
      subunits: null,
      quantity: null,
      locationId: null,
      locationName: "",
    };
  };

  const onChangeAdminValue = (name, value, ind, addObj) => {
    const reqObj = { ...procedValues };
    reqObj.adminList = procedValues?.adminList?.map((li, i) => {
      if (li?.i === ind) {
        const reqObj = { ...li, [name]: value };
        const qty = (name === "name" ? value : li?.quantity) ?? 0;
        if (name === "name" && addObj) {
          reqObj.type = addObj?.type;
          reqObj.stockId = addObj?.stockId;
          if (!li?.dosage && addObj?.stockId) {
            const reqStock = clinicStocks?.find(
              (stc) => stc?.stockId === addObj?.stockId,
            );
            const batchList = reqStock?.stockBatch;
            const reqBatch = reqStock?.autoConsumed
              ? null
              : getRequiredBatch(batchList);
            // if (reqBatch?.dosage?.length > 0) {
            reqObj.dosage = reqBatch?.dosage;
            const reqPack = reqBatch?.packageUom
              ? reqBatch?.packageUom?.match(/^(\d+)(.+)/)
              : null;
            const priceRatio =
              Number(reqBatch?.dosage ? reqBatch?.dosage : 0) /
              Number(reqPack?.[1] ? reqPack?.[1] : 0);
            const reqPrice =
              Number(
                reqBatch?.unitSellingPrice ? reqBatch?.unitSellingPrice : 0,
              ) * Number(priceRatio ? priceRatio : 0);
            reqObj.batchId = reqBatch?.batchId ?? null;
            reqObj.estCost = reqPrice ?? 0;
            // }
            reqObj.batchNumber = reqBatch
              ? { name: reqBatch?.batchNo, value: reqBatch?.batchId }
              : null;
          }
          if (li?.dosage) {
            if (addObj?.stockId) {
              const stckBatches = clinicStocks?.find(
                (stc) => stc?.stockId === addObj?.stockId,
              )?.stockBatch;
              const reqBatch = stckBatches?.find(
                (bat) =>
                  bat?.batchId ===
                  (addObj?.batchId ??
                    reqObj?.batchNumber?.value ??
                    reqObj?.batchId),
              );
              // const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
              // const priceRatio = Number(li?.dosage ?? 0) / Number(reqPack?.[1]);
              const reqPrice =
                (Number(reqBatch?.unitSellingPrice) ?? 0) * Number(qty ?? 0);
              reqObj.batchId = reqBatch?.batchId;
              reqObj.estCost = reqPrice;
              reqObj.batchNumber = {
                name: reqBatch?.batchNo,
                value: reqBatch?.batchId,
              };
            }
          }
          // if (!reqObj?.detailId) {
          //   reqObj.status = true;
          //   reqObj.reason = "";
          //   addUpdateAdminItems(reqObj);
          // }
        }
        if (name === "batchNumber") {
          const reqBatch = getBatch(li?.stockId, value?.value);
          reqObj.batchId = reqBatch ? value?.value : null;
          // const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
          // const priceRatio = Number(li?.dosage ?? 0) / Number(reqPack?.[1]);
          const reqPrice =
            (Number(reqBatch?.unitSellingPrice) ?? 0) * Number(qty ?? 0);
          reqObj.estCost = value?.value ? reqPrice : 0;
        }
        if (name === "status") {
          if (value) {
            reqObj.reason = "Completed";
            reqObj.status = true;
            addUpdateAdminItems(reqObj);
            // if (
            //   value !== "requested" &&
            //   (li?.type?.toLowerCase() === "flea & tick treatment" ||
            //     li?.type?.toLowerCase() === "vaccines" ||
            //     li?.type?.toLowerCase() === "deworming")
            // ) {
            //   setAdminValues({
            //     ...li,
            //     status: true,
            //     reason: "Completed",
            //     statusDrop: value,
            //     nextDueDate: datePlusOneDay,
            //   });
            //   setAdmUpdteModVsble(true);
            // } else {
            //   addUpdateAdminItems(reqObj);
            // }
          } else {
            setAdminValues({
              reason:
                value === "requested" ? "Requested" : reasonList?.[0]?.value,
              i: ind,
            });
            setAdmStatusVsble(true);
          }
        }
        if (name === "dosage") {
          const reqBatch = getBatch(
            li?.stockId,
            li?.batchNumber?.value ?? li?.batchId,
          );
          const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
          const priceRatio = Number(value) / Number(reqPack?.[1]);
          const reqPrice =
            (Number(reqBatch?.unitSellingPrice) ?? 0) * Number(priceRatio ?? 0);
          reqObj.estCost = reqPrice;
        }
        if (
          name === "linkToProcedure" &&
          (addObj?.serviceId || addObj?.variantId)
        ) {
          reqObj.serviceId = addObj?.serviceId;
          reqObj.variantId = addObj?.variantId;
        }
        return reqObj;
      }
      return li;
    });
    setProcedValues(reqObj);
  };

  const getBatches = (stkId = null) => {
    const reqStock = clinicStocks?.find((stc) => stc?.stockId === stkId);
    const primaryLocationMatch = reqStock?.stockBatch?.filter(
      (bat) =>
        // bat?.billlable === "Y" &&
        bat?.locationId === getReqFacility()?.primaryStorage,
    );
    const secondaryLocationMatch = reqStock?.stockBatch?.filter(
      (bat) =>
        // bat?.billlable === "Y" &&
        bat?.locationId === getReqFacility()?.secondaryStorage,
    );
    const otherLocationMatch = reqStock?.stockBatch?.filter(
      (bat) =>
        // bat?.billlable === "Y" &&
        bat?.locationId !== getReqFacility()?.secondaryStorage &&
        bat?.locationId !== getReqFacility()?.primaryStorage,
    );
    const reqList = [
      ...(primaryLocationMatch ?? []),
      ...(secondaryLocationMatch ?? []),
      ...(role === "ROLE_DOCTOR" ? [] : (otherLocationMatch ?? [])),
    ];
    return reqList?.length > 0
      ? reqList?.map((bat) => {
          const reqLocation = locationList?.find(
            (loc) => loc?.id === bat?.locationId,
          );
          return {
            name: bat?.batchNo,
            value: bat?.batchId,
            subunits: bat?.subunits,
            quantity: bat?.quantity,
            locationId: bat?.locationId,
            locationName: reqLocation?.locationName ?? "",
          };
        })
      : [
          {
            name: "Unknown",
            value: null,
            subunits: null,
            quantity: null,
            locationId: null,
            locationName: "",
          },
        ];
  };

  const deletePresDetailById = (id) => {
    dispatch(deletePrescriptionItemByIdWoLoader(id)).then((res) => {
      if (res?.payload) {
        onCloseDelMod();
        onApiCall();
      }
    });
  };

  const deletePresByIndex = (ind) => {
    const reqObj = { ...procedValues };
    reqObj.presList = procedValues?.presList
      ?.reduce((acc, item) => {
        if (item?.i === ind) {
          if (item?.detailId != null || item?.detailId !== undefined) {
            acc.push(item);
            setSelectedItem({ item: item, type: "presDetail" });
            setDelModVsble(true);
            // deletePresDetailById(item?.detailId);
          }
        } else {
          acc.push(item);
        }
        return acc;
      }, [])
      ?.map((cl, i) => ({ ...cl, i }));
    setProcedValues(reqObj);
  };

  const addUpdateConsumItems = (obj) => {
    if (obj?.serviceId) {
      const reqProced = reqDet?.procedures?.find(
        (pl) => pl?.serviceId === obj?.serviceId,
      );
      if (!reqProced?.procedureId) return;
      const reqServ = services?.find(
        (ser) =>
          ser?.serviceId === obj?.serviceId ??
          obj?.assignToProcedure?.serviceId,
      );
      const reqVar = reqServ?.serviceVariants?.find(
        (vnt) =>
          vnt?.variantName?.toLowerCase() ===
          reqProced?.serviceType?.toLowerCase(),
      );
      const reqStock = clinicStocks?.find(
        (stc) => stc?.stockId === (obj?.stockId ?? obj?.name?.stockId),
      );
      const isNoAmount =
        reqStock?.autoConsumed || !reqStock?.billable || obj?.linkToProcedure;
      const reqBat = reqStock?.autoConsumed
        ? reqStock?.stockBatch?.[0]
        : obj?.batchId
          ? (reqStock?.stockBatch?.find(
              (bat) => bat?.batchId === obj?.batchId,
            ) ?? reqStock?.stockBatch?.[0])
          : reqStock?.stockBatch?.[0];
      const currLocat = locationList?.find(
        (loc) => loc?.id === reqBat?.locationId,
      );
      const reqUnitPrice = isNoAmount
        ? 0
        : (reqBat?.unitSellingPrice ??
          reqStock?.stockBatch?.[0]?.unitSellingPrice ??
          0);
      const taxPerent =
        reqServ?.taxApplicability?.toLowerCase() === "yes"
          ? Number(reqBat?.cgst ?? 0) + Number(reqBat?.sgst ?? 0)
          : 0;
      const reqPercent = 100 + Number(taxPerent);
      const unitPrice = Number(reqUnitPrice) / (reqPercent / 100);
      const priceAfterDiscount = Number(unitPrice);
      const prdTaxValue = (taxPerent / 100) * Number(priceAfterDiscount);
      const reqObj = {
        detailId: obj?.detailId ?? null,
        stockId: obj?.stockId ?? null,
        batchId:
          obj?.batchId ?? (reqStock?.autoConsumed ? reqBat?.batchId : null),
        type: "Consumables",
        quantity: Number(obj?.quantity),
        status: reqStock?.autoConsumed
          ? obj?.detailId
            ? obj?.status
            : true
          : (obj?.batchId ?? obj?.batchNumber?.value)
            ? obj?.status
            : "requested",
        remarks: obj?.reason,
        estimatedCost: isNoAmount
          ? 0
          : (Number(reqUnitPrice) * Number(obj?.quantity ?? 1) ??
            obj?.estCost ??
            0),
        name: obj?.name,
        procedureName: obj?.name,
        isDelete: false,
        serviceId: obj?.serviceId ?? null,
        tax: isNoAmount
          ? 0
          : Number(prdTaxValue ?? 0) * Number(obj?.quantity ?? 1),
        total: isNoAmount
          ? 0
          : Number(reqUnitPrice) * Number(obj?.quantity ?? 1),
        mrpPrice: isNoAmount ? 0 : Number(reqUnitPrice ?? 0),
        procedureVariantId:
          obj?.assignToProcedure?.variantId ??
          obj?.variantId ??
          reqVar?.variantId,
        patientWorkbook: true,
        mainProcedure: false,
        drugSchedule: reqServ?.drugSchedule ?? null,
        hsnSacCode: reqServ?.hsnSacCode ?? null,
        packageUom: reqBat?.salesUom ?? null,
        expiryDate: reqBat?.expiryDate ?? null,
        batchNo: reqBat?.batchNo ?? null,
        billable: reqStock?.billable,
        autoConsumed: reqStock?.autoConsumed,
        linked: !obj?.linkToProcedure ? "N" : null,
        billType: currLocat?.category
          ? billingTabEnum?.[currLocat?.category]
          : null,
      };
      let tax = 0;
      let total = reqVar?.serviceCharge ?? reqProced?.serviceCharge ?? 0;
      if (reqServ?.taxApplicability?.toLowerCase() === "yes") {
        tax +=
          reqServ?.taxApplicability?.toLowerCase() === "yes"
            ? (Number(reqVar?.serviceCharge ?? 0) / 100) *
              Number(reqServ?.tax ?? 0)
            : 0;
        total += tax;
      }
      dispatch(
        updateProcedureByIdWoLoader({
          id: reqProced?.procedureId,
          data: {
            serviceCharge: reqProced?.serviceCharge,
            serviceType: reqProced?.serviceType,
            appointmentId: reqDet?.appointment?.appointmentId,
            procedureDetails: [reqObj],
            tax,
            total,
            mrpPrice: Number(reqVar?.serviceCharge ?? 0),
            procedureVariantId:
              obj?.variantId ??
              obj?.assignToProcedure?.variantId ??
              reqVar?.variantId,
            quantity: 1,
            hsnSacCode: reqServ?.hsnSacCode ?? null,
          },
        }),
      ).then((res) => {
        if (res?.payload) {
          onApiCall();
          onCloseFileMod();
        }
      });
    }
    updateCheckoutStatus();
  };

  const onSaveMultiConsums = () => {
    const serviceIds = (procedValues?.consumList ?? [])?.map(
      (li) => li?.serviceId,
    );
    const uniqServiceIds = uniq(serviceIds);
    const groupByConsum = groupBy(procedValues?.consumList ?? [], "serviceId");
    uniqServiceIds?.forEach((servId, i) => {
      const reqProced = reqDet?.procedures?.find(
        (pl) => pl?.serviceId === servId,
      );
      if (!reqProced?.procedureId) return;
      const reqServ = services?.find((ser) => ser?.serviceId === servId);
      const reqVar = reqServ?.serviceVariants?.find(
        (vnt) =>
          vnt?.variantName?.toLowerCase() ===
          reqProced?.serviceType?.toLowerCase(),
      );
      const reqProcedureDetails = groupByConsum?.[servId]?.map((obj) => {
        const reqStock = clinicStocks?.find(
          (stc) => stc?.stockId === (obj?.stockId ?? obj?.name?.stockId),
        );
        const isNoAmount =
          reqStock?.autoConsumed || !reqStock?.billable || obj?.linkToProcedure;
        const reqBat = reqStock?.autoConsumed
          ? reqStock?.stockBatch?.[0]
          : obj?.batchId
            ? (reqStock?.stockBatch?.find(
                (bat) => bat?.batchId === obj?.batchId,
              ) ?? reqStock?.stockBatch?.[0])
            : reqStock?.stockBatch?.[0];
        const currLocat = locationList?.find(
          (loc) => loc?.id === reqBat?.locationId,
        );
        const reqUnitPrice = isNoAmount
          ? 0
          : (reqBat?.unitSellingPrice ??
            reqStock?.stockBatch?.[0]?.unitSellingPrice ??
            0);
        const taxPerent =
          reqServ?.taxApplicability?.toLowerCase() === "yes"
            ? Number(reqBat?.cgst ?? 0) + Number(reqBat?.sgst ?? 0)
            : 0;
        const reqPercent = 100 + Number(taxPerent);
        const unitPrice = Number(reqUnitPrice) / (reqPercent / 100);
        const priceAfterDiscount = Number(unitPrice);
        const prdTaxValue = (taxPerent / 100) * Number(priceAfterDiscount);
        const reqObj = {
          detailId: obj?.detailId ?? null,
          stockId: obj?.stockId ?? null,
          batchId:
            obj?.batchId ?? (reqStock?.autoConsumed ? reqBat?.batchId : null),
          type: "Consumables",
          quantity: Number(obj?.quantity),
          status: reqStock?.autoConsumed
            ? obj?.detailId
              ? obj?.status
              : true
            : (obj?.batchId ?? obj?.batchNumber?.value)
              ? true
              : "requested",
          remarks: obj?.reason,
          estimatedCost: isNoAmount
            ? 0
            : (Number(reqUnitPrice) * Number(obj?.quantity ?? 1) ??
              obj?.estCost ??
              0),
          name: obj?.name,
          procedureName: obj?.name,
          isDelete: false,
          serviceId: obj?.serviceId ?? null,
          tax: isNoAmount
            ? 0
            : Number(prdTaxValue ?? 0) * Number(obj?.quantity ?? 1),
          total: isNoAmount
            ? 0
            : Number(reqUnitPrice) * Number(obj?.quantity ?? 1),
          mrpPrice: isNoAmount ? 0 : Number(reqUnitPrice ?? 0),
          procedureVariantId:
            obj?.assignToProcedure?.variantId ??
            obj?.variantId ??
            reqVar?.variantId,
          patientWorkbook: true,
          mainProcedure: false,
          drugSchedule: reqServ?.drugSchedule ?? null,
          hsnSacCode: reqServ?.hsnSacCode ?? null,
          packageUom: reqBat?.salesUom ?? null,
          expiryDate: reqBat?.expiryDate ?? null,
          batchNo: reqBat?.batchNo ?? null,
          billable: reqStock?.billable,
          autoConsumed: reqStock?.autoConsumed,
          linked: !obj?.linkToProcedure ? "N" : "Y",
          billType: reqStock?.autoConsumed
            ? currLocat?.category
              ? billingTabEnum?.[currLocat?.category]
              : "treatment"
            : "treatment",
        };
        return reqObj;
      });
      let tax = 0;
      let total = reqVar?.servicePrice ?? reqProced?.serviceCharge ?? 0;
      if (reqServ?.taxApplicability?.toLowerCase() === "yes") {
        tax +=
          reqServ?.taxApplicability?.toLowerCase() === "yes"
            ? (Number(reqVar?.servicePrice ?? 0) / 100) *
              Number(reqServ?.tax ?? 0)
            : 0;
        total += tax;
      }
      dispatch(
        updateProcedureByIdWoLoader({
          id: reqProced?.procedureId,
          data: {
            serviceCharge: reqProced?.serviceCharge,
            serviceType: reqProced?.serviceType,
            appointmentId: reqDet?.appointment?.appointmentId,
            procedureDetails: reqProcedureDetails,
            tax: Number(Number(tax) * Number(reqProced?.quantity)),
            total: Number(Number(total) * Number(reqProced?.quantity)),
            mrpPrice: Number(reqVar?.servicePrice ?? 0),
            procedureVariantId: reqVar?.variantId,
            quantity: Number(reqProced?.quantity),
            hsnSacCode: reqServ?.hsnSacCode ?? null,
          },
        }),
      ).then((res) => {
        if (res?.payload) {
          if (uniqServiceIds?.length === i + 1) {
            onApiCall();
            onCloseFileMod();
          }
        }
      });
    });
  };

  const onSaveMultiAdmins = () => {
    const serviceIds = (procedValues?.adminList ?? [])?.map(
      (li) => li?.serviceId,
    );
    const uniqServiceIds = uniq(serviceIds);
    const groupByConsum = groupBy(procedValues?.adminList ?? [], "serviceId");
    uniqServiceIds?.forEach((servId, i) => {
      const reqProced = reqDet?.procedures?.find(
        (pl) => pl?.serviceId === servId,
      );
      if (!reqProced?.procedureId) return;
      const reqServ = services?.find((ser) => ser?.serviceId === servId);
      const reqVar = reqServ?.serviceVariants?.find(
        (vnt) =>
          vnt?.variantName?.toLowerCase() ===
          reqProced?.serviceType?.toLowerCase(),
      );
      const reqProcedureDetails = groupByConsum?.[servId]?.map((obj) => {
        const reqStock = clinicStocks?.find(
          (stc) => stc?.stockId === obj?.stockId,
        );
        const isNoAmount =
          reqStock?.autoConsumed || !reqStock?.billable || obj?.linkToProcedure;
        const reqBat = reqStock?.autoConsumed
          ? reqStock?.stockBatch?.[0]
          : obj?.batchId
            ? (reqStock?.stockBatch?.find(
                (bat) => bat?.batchId === obj?.batchId,
              ) ?? reqStock?.stockBatch?.[0])
            : reqStock?.stockBatch?.[0];
        const reqUnitPrice =
          reqBat?.unitSellingPrice ??
          reqStock?.stockBatch?.[0]?.unitSellingPrice ??
          0;
        const currLocat = locationList?.find(
          (loc) => loc?.id === reqBat?.locationId,
        );
        const taxPerent =
          reqServ?.taxApplicability?.toLowerCase() === "yes"
            ? Number(reqBat?.cgst ?? 0) + Number(reqBat?.sgst ?? 0)
            : 0;
        const reqPercent = 100 + Number(taxPerent);
        const reqPrice =
          (Number(reqUnitPrice) ?? 0) * Number(obj?.quantity ?? 0);
        const unitPrice = Number(reqPrice) / (reqPercent / 100);
        const priceAfterDiscount = Number(unitPrice);
        const prdTaxValue = (taxPerent / 100) * Number(priceAfterDiscount);
        const reqObj = {
          detailId: obj?.detailId ?? null,
          stockId: obj?.stockId ?? null,
          batchId:
            obj?.batchId ??
            obj?.batchNumber?.value ??
            (reqStock?.autoConsumed ? reqBat?.batchId : null),
          type: "Administered",
          quantity: Number(obj?.quantity ?? 1),
          status: reqStock?.autoConsumed
            ? obj?.detailId
              ? obj?.status
              : true
            : (obj?.batchId ?? obj?.batchNumber?.value)
              ? true
              : "requested",
          remarks: obj?.reason,
          estimatedCost: isNoAmount ? 0 : (reqPrice ?? obj?.estCost ?? 0),
          name: obj?.name,
          procedureName: obj?.name,
          dosage: obj?.dosage,
          route: obj?.route?.value ?? null,
          isDelete: false,
          serviceId: obj?.serviceId,
          itemIssued: obj?.itemIssued,
          itemIssuedStatus: obj?.itemIssuedStatus,
          tax: isNoAmount ? 0 : Number(prdTaxValue ?? 0),
          total: isNoAmount ? 0 : Number(reqPrice ?? 0),
          mrpPrice: isNoAmount ? 0 : Number(reqUnitPrice ?? 0),
          procedureVariantId:
            obj?.assignToProcedure?.variantId ??
            obj?.variantId ??
            reqVar?.variantId,
          patientWorkbook: true,
          mainProcedure: false,
          drugSchedule: reqServ?.drugSchedule ?? null,
          hsnSacCode: reqServ?.hsnSacCode ?? null,
          packageUom: reqBat?.salesUom ?? null,
          expiryDate: reqBat?.expiryDate ?? null,
          batchNo: reqBat?.batchNo ?? null,
          billable: reqStock?.billable,
          autoConsumed: reqStock?.autoConsumed,
          linked: !obj?.linkToProcedure ? "N" : "Y",
          billType: reqStock?.autoConsumed
            ? currLocat?.category
              ? billingTabEnum?.[currLocat?.category]
              : "treatment"
            : "treatment",
        };
        return reqObj;
      });
      let tax = 0;
      let total = reqVar?.servicePrice ?? reqProced?.serviceCharge ?? 0;
      if (reqServ?.taxApplicability?.toLowerCase() === "yes") {
        tax +=
          reqServ?.taxApplicability?.toLowerCase() === "yes"
            ? (Number(reqVar?.servicePrice ?? 0) / 100) *
              Number(reqServ?.tax ?? 0)
            : 0;
        total += tax;
      }
      dispatch(
        updateProcedureByIdWoLoader({
          id: reqProced?.procedureId,
          data: {
            serviceCharge: reqProced?.serviceCharge,
            serviceType: reqProced?.serviceType,
            appointmentId: reqDet?.appointment?.appointmentId,
            procedureDetails: reqProcedureDetails,
            tax: Number(Number(tax) * Number(reqProced?.quantity)),
            total: Number(Number(total) * Number(reqProced?.quantity)),
            mrpPrice: Number(reqVar?.servicePrice ?? 0),
            procedureVariantId: reqVar?.variantId,
            quantity: Number(reqProced?.quantity),
            hsnSacCode: reqServ?.hsnSacCode ?? null,
          },
        }),
      ).then((res) => {
        if (res?.payload) {
          if (uniqServiceIds?.length === i + 1) {
            onApiCall();
            onCloseFileMod();
          }
        }
      });
    });
  };

  const onChangeConsumValue = (name, value, ind, addObj) => {
    const reqList = procedValues?.consumList?.map((li) => {
      if (li?.i === ind) {
        const reqObj = { ...li, [name]: value };
        if (name === "name" && addObj) {
          reqObj.stockId = addObj?.stockId ?? li?.stockId;
          reqObj.batchId = addObj?.batchId ?? li?.batchId ?? null;
          reqObj.serviceId = addObj?.serviceId ?? li?.serviceId;
          reqObj.category = addObj?.category ?? li?.category;
          const reqStock = clinicStocks?.find(
            (stc) => stc?.stockId === addObj?.stockId,
          );
          const batchList = reqStock?.stockBatch;
          const reqBatch = reqStock?.autoConsumed
            ? null
            : getRequiredBatch(batchList);
          // if (addObj?.stockId ?? li?.stockId) {
          reqObj.batchId = reqBatch?.batchId ?? null;
          const reqCost =
            Number(reqBatch?.unitSellingPrice ?? 0) * Number(li?.quantity ?? 1);
          reqObj.estCost = reqCost;
          reqObj.batchNumber = reqBatch
            ? { name: reqBatch?.batchNo, value: reqBatch?.batchId }
            : null;
          // }
          // if (!reqObj?.detailId) {
          //   reqObj.status = true;
          //   reqObj.reason = "";
          //   addUpdateConsumItems(reqObj);
          // }
        }
        if (name === "batchNumber") {
          const reqBatch = getBatch(li?.stockId, value?.value);
          reqObj.batchId = reqBatch ? value?.value : null;
          const reqPrice =
            (Number(reqBatch?.unitSellingPrice) ?? 0) *
            Number(li?.quantity ?? 1);
          reqObj.estCost = value?.value ? reqPrice : 0;
        }
        if (name === "quantity") {
          const price = getItemPrice(li?.stockId ?? null, li?.batchId ?? null);
          reqObj.estCost = Number(price) * Number(value ?? 1);
        }
        if (name === "status") {
          if (value) {
            reqObj.reason = "";
            addUpdateConsumItems(reqObj);
          } else {
            setConsumValues({ reason: reasonList?.[0]?.value, i: ind });
            setConStatusVsble(true);
          }
        }
        if (
          name === "linkToProcedure" &&
          (addObj?.serviceId || addObj?.variantId)
        ) {
          reqObj.serviceId = addObj?.serviceId;
          reqObj.variantId = addObj?.variantId;
        }
        return reqObj;
      }
      return li;
    });
    setProcedValues({ ...procedValues, consumList: reqList });
  };

  const handleChangePresValue = (name, value, ind, addObj) => {
    const reqList = procedValues?.presList?.map((pl, i) => {
      if (i === ind) {
        const reqObj = { ...pl, [name]: value };
        if (name === "frequency") {
          if (value?.includes("Custom")) {
            reqObj.frequency = "";
            reqObj.customFrequency = true;
          }
        }
        if (name === "plName" && addObj) {
          reqObj.type = addObj?.type;
          reqObj.stockId = addObj?.stockId;
          if (addObj?.stockId) {
            const reqBatch = clinicStocks?.find(
              (stc) => stc?.stockId === addObj?.stockId,
            )?.stockBatch?.[0];
            reqObj.batchId = reqBatch?.batchId;
            reqObj.dosage = reqBatch?.dosage;
          }
        }
        if (name === "type") reqObj.name = null;
        if (addObj?.productId) {
          reqObj.productId = addObj?.productId;
        }
        if (addObj?.serviceId) reqObj.serviceId = addObj?.serviceId;
        return reqObj;
      }
      return pl;
    });
    setProcedValues({ ...procedValues, presList: reqList });
  };

  const handleObjOpen = (name, value) => {
    setObjOpen({ ...objOpen, [name]: value });
  };

  const onAddFiles = (type) => {
    setFileValues({ ...fileValues, modVsble: true, type });
  };

  const addNewAdminister = () => {
    const reqObj = { ...procedValues };
    const reqList = procedValues?.adminList;
    reqList.push({
      name: "",
      batchNumber: null,
      quantity: 1,
      dosage: "",
      route: null,
      reason: null,
      i: procedValues?.adminList?.length,
      deleteable: true,
      isEdit: true,
      estCost: 0,
      status: null,
      delete: false,
      serviceId: procedures?.[0]?.service?.serviceId ?? null,
      variantId: procedures?.[0]?.variant?.variantId ?? null,
      linkToProcedure: null,
      // {
      //   name: procedures?.[0]?.service?.name,
      //   value: procedures?.[0]?.service?.name,
      //   serviceId: procedures?.[0]?.service?.serviceId,
      //   varinatName: procedures?.[0]?.variant?.name,
      //   variantId: procedures?.[0]?.variant?.variantId,
      // },
    });
    reqObj.adminList = reqList;
    setProcedValues(reqObj);
  };

  const getDropList = (li) => {
    const list = [
      {
        name: li?.name,
        value: li?.name,
        stockId: li?.stockId,
        batchId: li?.batchId,
      },
    ];
    if (li?.alternates?.length > 0) {
      li?.alternates?.forEach((al) => {
        list.push({
          name: al?.name,
          value: al?.name,
          stockId: al?.stockId,
          batchId: al?.batchId,
        });
      });
    }
    return uniqBy(list, "stockId");
  };

  const getList = (isPres = false) => {
    let reqList = [];
    if (isPres) {
      reqList = clinicStocks?.filter((dta) => {
        return (
          dta?.active === "Y" &&
          // dta?.billable &&
          (dta?.category?.toLowerCase() === "deworming" ||
            dta?.category?.toLowerCase() === "diet" ||
            dta?.category?.toLowerCase() === "flea & tick treatment" ||
            dta?.category?.toLowerCase() === "fluid therapy" ||
            dta?.category?.toLowerCase() === "grooming & hygiene care" ||
            dta?.category?.toLowerCase() === "medication" ||
            dta?.category?.toLowerCase() === "nutrition and supplements" ||
            dta?.category?.toLowerCase() === "other parasite treatment" ||
            dta?.category?.toLowerCase() === "vaccines")
        );
      });
    } else {
      reqList = clinicStocks?.filter((dta) => {
        return (
          dta?.active === "Y" &&
          // dta?.billable &&
          (dta?.category?.toLowerCase() === "general consumables" ||
            dta?.category?.toLowerCase() === "medical supplies" ||
            dta?.category?.toLowerCase() === "surgical supplies" ||
            dta?.category?.toLowerCase() === "lab consumables" ||
            dta?.category?.toLowerCase() === "lab supplies" ||
            dta?.category?.toLowerCase() === "cleaning supplies" ||
            dta?.category?.toLowerCase() === "grooming & hygiene care" ||
            dta?.category?.toLowerCase() === "fluid therapy" ||
            dta?.category?.toLowerCase() === "mortuary")
        );
      });
    }
    return reqList?.map((li) => ({
      name: li?.productName ?? li?.tradeName,
      value: li?.productName ?? li?.tradeName,
      stockId: li?.stockId,
      type: li?.category,
      productName: li?.productName,
      tradeName: li?.tradeName,
    }));
  };

  const getPresList = () => {
    const reqList = clinicStocks?.filter((dta) => {
      return (
        dta?.active === "Y" &&
        dta?.billable &&
        (dta?.category?.toLowerCase() === "medication" ||
          dta?.category?.toLowerCase() === "diet" ||
          dta?.category?.toLowerCase() === "nutrition and supplements" ||
          dta?.category?.toLowerCase() === "fluid therapy" ||
          dta?.category?.toLowerCase() === "other parasite treatment" ||
          dta?.category?.toLowerCase() === "deworming" ||
          dta?.category?.toLowerCase() === "flea & tick treatment" ||
          dta?.category?.toLowerCase() === "grooming & hygiene care")
      );
    });
    return reqList?.map((li) => ({
      name: li?.tradeName ?? li?.productName,
      value: li?.tradeName ?? li?.productName,
      stockId: li?.stockId,
      type: li?.category,
      productName: li?.productName,
      tradeName: li?.tradeName,
    }));
  };

  const deleteMultipleDetailIds = (ids = []) => {
    ids?.forEach((id) => {
      dispatch(deleteProcedureDetailByIdWoLoader(id));
    });
  };

  const updateCheckoutStatus = () => {
    if (
      appDet?.appointmentStatus?.toLowerCase() !== "completed" &&
      (appDet?.checkOut === "Y" ||
        appDet?.pharmacyCheckout === "Y" ||
        appDet?.petShopCheckout === "Y")
    ) {
      const reqObj = petBilling?.data?.find(
        (pl) => pl?.appointmentId === appDet?.appointmentId,
      );
      if (!reqObj?.paymentId) return;
      dispatch(
        enableCheckoutByAppointmentId({
          apntId: appDet?.appointmentId,
          paymentId: reqObj?.paymentId,
          url: "?treatmentCheckout=N&petShopCheckout=N&pharmacyCheckout=N",
        }),
      );
    }
  };

  const createUpdateProcedure = async (prcd) => {
    if (
      !(prcd?.serviceId ?? prcd?.service?.serviceId) ||
      !(prcd?.variantId ?? prcd?.variant?.variantId) ||
      !prcd?.quantity ||
      prcd?.quantity === 0
    ) {
      return;
    }
    const reqQty = Number(prcd?.quantity) > 0 ? Number(prcd?.quantity) : 1;
    if (!prcd?.service?.procedureId && !prcd?.prevServId) {
      const procedureDetailsResult = await getProcedureDetailsNew({
        servId: prcd?.serviceId ?? prcd?.service?.serviceId,
        varntId: prcd?.variantId ?? prcd?.variant?.variantId,
        services: services ?? [],
        clinicStocks: clinicStocks ?? [],
        pharmacyTaxId: clinicDet?.pharmacyTaxId,
        status: true,
        facilities,
        facilityId: appDet?.facilityId,
        patientWorkbook: true,
        locations: locationList ?? [],
      });
      const procedureDetails = procedureDetailsResult?.procedureDetails;
      if (procedureDetailsResult?.prescriptions?.length > 0) {
        const data = {
          status: "Pending",
          remark: "",
          prescription: procedureDetailsResult?.prescriptions,
          issue: "",
          paymentId: reqDet?.paymentId ?? null,
        };
        if (reqDet?.prescription?.[0]?.prescriptionId) {
          dispatch(
            updatePrescriptionByIdWoLoader({
              prescriptionId: reqDet?.prescription?.[0]?.prescriptionId,
              data,
            }),
          );
        } else {
          dispatch(
            createPrescriptionWoLoader({
              appointmentId: appDet?.appointmentId,
              data,
            }),
          );
        }
      }
      const resServ = services?.find(
        (ser) => ser?.serviceId === prcd?.service?.serviceId,
      );
      const reqVar = resServ?.serviceVariants?.find(
        (vnt) => vnt?.variantName === prcd?.variant?.name,
      );
      let tax = 0;
      let total = reqVar?.servicePrice ?? prcd?.variant?.servicePrice ?? 0;
      if (resServ?.taxApplicability?.toLowerCase() === "yes") {
        tax +=
          resServ?.taxApplicability?.toLowerCase() === "yes"
            ? (Number(reqVar?.servicePrice ?? 0) / 100) *
              Number(resServ?.tax ?? 0)
            : 0;
        total += tax;
      }
      const data = {
        procedureName: prcd?.service?.name,
        serviceId: prcd?.service?.serviceId,
        category: prcd?.service?.category,
        subCategory: prcd?.service?.subCategory,
        remarks: prcd?.service?.remarks,
        doneAt: moment(new Date()).format("YYYY-MM-DD"),
        status: "Pending",
        petId: appDet?.petId,
        appointmentId: appDet?.appointmentId,
        serviceCharge: prcd?.variant?.servicePrice,
        serviceType: getOnlyName(prcd?.variant?.name),
        procedureDetails,
        tax: Number(Number(tax) * Number(reqQty)) ?? 0,
        total: Number(Number(total) * Number(reqQty)) ?? 0,
        mrpPrice: Number(
          reqVar?.servicePrice ?? prcd?.variant?.servicePrice ?? 0,
        ),
        procedureVariantId: prcd?.variant?.variantId,
        quantity: Number(reqQty),
        patientWorkbook: true,
        mainProcedure: true,
        hsnSacCode: resServ?.hsnSacCode ?? null,
        paymentId: reqDet?.paymentId ?? null,
      };
      dispatch(createProcedureWoLoader({ data })).then((res) => {
        if (res?.payload) onApiCall();
      });
    } else {
      if (
        procedValues?.consumList?.some(
          (cl) => typeof cl?.status === "boolean",
        ) ||
        procedValues?.adminList?.some((cl) => typeof cl?.status === "boolean")
      ) {
        setSelectedProcedure({ ...prcd, type: "variantChange" });
        return setChangeWarnVsble(true);
      } else {
        await dispatch(deleteProcedureByIdWoLoader(prcd?.procedureId));
        const procedureDetailsResult = await getProcedureDetailsNew({
          servId: prcd?.serviceId ?? prcd?.service?.serviceId,
          varntId: prcd?.variantId ?? prcd?.variant?.variantId,
          services: services ?? [],
          clinicStocks: clinicStocks ?? [],
          pharmacyTaxId: clinicDet?.pharmacyTaxId,
          status: true,
          facilities,
          facilityId: appDet?.facilityId,
          patientWorkbook: true,
          locations: locationList ?? [],
        });
        const procedureDetails = procedureDetailsResult?.procedureDetails;
        if (procedureDetailsResult?.prescriptions?.length > 0) {
          const data = {
            status: "Pending",
            remark: "",
            prescription: procedureDetailsResult?.prescriptions,
            issue: "",
            paymentId: reqDet?.paymentId ?? null,
          };
          if (reqDet?.prescription?.[0]?.prescriptionId) {
            dispatch(
              updatePrescriptionByIdWoLoader({
                prescriptionId: reqDet?.prescription?.[0]?.prescriptionId,
                data,
              }),
            );
          } else {
            dispatch(
              createPrescriptionWoLoader({
                appointmentId: appDet?.appointmentId,
                data,
              }),
            );
          }
        }
        const resServ = services?.find(
          (ser) => ser?.serviceId === prcd?.service?.serviceId,
        );
        const reqVar = resServ?.serviceVariants?.find(
          (vnt) => vnt?.variantName === prcd?.variant?.name,
        );
        let tax = 0;
        let total = reqVar?.serviceCharge ?? prcd?.variant?.serviceCharge ?? 0;
        if (resServ?.taxApplicability?.toLowerCase() === "yes") {
          tax +=
            resServ?.taxApplicability?.toLowerCase() === "yes"
              ? (Number(reqVar?.serviceCharge ?? 0) / 100) *
                Number(resServ?.tax ?? 0)
              : 0;
          total += tax;
        }
        const data = {
          procedureName: prcd?.service?.name,
          serviceId: prcd?.service?.serviceId,
          category: prcd?.service?.category,
          subCategory: prcd?.service?.subCategory,
          remarks: prcd?.service?.remarks,
          doneAt: moment(new Date()).format("YYYY-MM-DD"),
          status: "Pending",
          petId: appDet?.petId,
          appointmentId: appDet?.appointmentId,
          serviceCharge: prcd?.variant?.serviceCharge,
          serviceType: getOnlyName(prcd?.variant?.name),
          procedureDetails,
          tax: Number(Number(tax) * Number(reqQty)),
          total: Number(Number(total) * Number(reqQty)),
          mrpPrice: Number(reqVar?.serviceCharge ?? 0),
          procedureVariantId: prcd?.variant?.variantId,
          quantity: Number(reqQty),
          patientWorkbook: true,
          mainProcedure: true,
          hsnSacCode: resServ?.hsnSacCode ?? null,
          paymentId: reqDet?.paymentId ?? null,
        };
        dispatch(createProcedureWoLoader({ data })).then((res) => {
          if (res?.payload) onApiCall();
        });
      }
    }
    updateCheckoutStatus();
  };

  const deleteProcedureDetailById = (id) => {
    dispatch(deleteProcedureDetailByIdWoLoader(id)).then((res) => {
      if (res?.payload) {
        onCloseDelMod();
        onApiCall();
      }
    });
  };

  const handleConsumDelete = (ind) => {
    const reqObj = { ...procedValues };
    reqObj.consumList = procedValues?.consumList
      ?.reduce((acc, item) => {
        if (item?.i === ind) {
          if (item?.detailId != null || item?.detailId !== undefined) {
            acc.push(item);
            setSelectedItem({ item: item, type: "procedureDetail" });
            setDelModVsble(true);
            // deleteProcedureDetailById(item?.detailId);
          }
        } else {
          acc.push(item);
        }
        return acc;
      }, [])
      ?.map((cl, i) => ({ ...cl, i }));
    setProcedValues(reqObj);
  };

  const getProcedureListAsDrop = () => {
    if (procedures?.length === 0 || !procedures) return [];
    const reqProcedures = procedures
      ?.filter?.((li) => li?.service?.serviceId && li?.variant?.variantId)
      ?.map((prcd) => {
        return {
          name: prcd?.service?.name,
          value: prcd?.service?.name,
          serviceId: prcd?.service?.serviceId,
          varinatName: prcd?.variant?.name,
          variantId: prcd?.variant?.variantId,
        };
      });
    return reqProcedures;
  };

  const addProcedure = () => {
    const reqList = [...procedures];
    reqList.push({
      i: procedures?.length,
      serviceId: procedures?.[0]?.service?.serviceId ?? null,
      editable: true,
      quantity: 1,
    });
    setProcedures(reqList);
  };

  const addNewConsumable = () => {
    const reqObj = { ...procedValues };
    const reqList = procedValues?.consumList;
    reqList.push({
      name: "",
      batchNumber: null,
      quantity: 1,
      reason: null,
      i: procedValues?.consumList?.length,
      deleteable: true,
      isEdit: true,
      estCost: 0,
      status: null,
      delete: false,
      serviceId: procedures?.[0]?.service?.serviceId ?? null,
      variantId: procedures?.[0]?.variant?.variantId ?? null,
      linkToProcedure: null,
      //  {
      //   name: procedures?.[0]?.service?.name,
      //   value: procedures?.[0]?.service?.name,
      //   serviceId: procedures?.[0]?.service?.serviceId,
      //   varinatName: procedures?.[0]?.variant?.name,
      //   variantId: procedures?.[0]?.variant?.variantId,
      // },
    });
    reqObj.consumList = reqList;
    setProcedValues(reqObj);
  };

  const handleConsumEdit = (ind) => {
    const reqObj = { ...procedValues };
    const reqList = procedValues?.consumList?.map((li) => {
      if (li?.i === ind) {
        return {
          ...li,
          isEdit: true,
          status: li?.detailId ? li?.status : null,
        };
      }
      return li;
    });
    reqObj.consumList = reqList;
    setProcedValues(reqObj);
  };

  const handleAdminDelete = (ind) => {
    const reqObj = { ...procedValues };
    reqObj.adminList = procedValues?.adminList
      ?.reduce((acc, item) => {
        if (item?.i === ind) {
          if (item?.detailId != null || item?.detailId !== undefined) {
            acc.push(item);
            setSelectedItem({ item: item, type: "procedureDetail" });
            setDelModVsble(true);
            // deleteProcedureDetailById(item?.detailId);
          }
        } else {
          acc.push(item);
        }
        return acc;
      }, [])
      ?.map((cl, i) => ({ ...cl, i }));
    setProcedValues(reqObj);
  };

  // const handleAdminEdit = (ind) => {
  //   const reqObj = { ...procedValues };
  //   reqObj.adminList = procedValues?.adminList?.map((li) => {
  //     if (li?.i === ind) {
  //       setAdminValues({
  //         ...li,
  //         statusDrop: typeof li?.status === "boolean" ? li?.status : null,
  //       });
  //       setAdmUpdteModVsble(true);
  //       return li;
  //     }
  //     return li;
  //   });
  //   setProcedValues(reqObj);
  // };

  const handleAdminEdit = (ind) => {
    const reqObj = { ...procedValues };
    const reqList = procedValues?.adminList?.map((li) => {
      if (li?.i === ind) {
        return {
          ...li,
          isEdit: true,
          status: li?.detailId ? li?.status : null,
        };
      }
      return li;
    });
    reqObj.adminList = reqList;
    setProcedValues(reqObj);
  };

  const addUpdatePresItems = () => {
    // if (
    //   pre?.plName === "" ||
    //   pre?.plName === null ||
    //   pre?.plName === undefined
    // ) {
    //   return;
    // }
    const reqPres = procedValues?.presList?.map((pre) => {
      const selStock = clinicStocks?.find(
        (stc) => stc?.stockId === pre?.stockId,
      );
      const btchDet = selStock?.stockBatch?.[0];
      const reqFreqList =
        Array.isArray(pre?.frequency) && pre?.frequency?.length > 0
          ? pre?.frequency?.map((fre) => fre?.apiValue)
          : ["onceDaily"];
      const reqPackValue = pre?.stockId
        ? getRightPackageUom(btchDet?.packageUom, false, true)
        : 1;
      const feedFrequency = getFeedingFrequency(reqFreqList);
      const reqDose =
        Number(pre?.dosage ?? "1") *
          Number(feedFrequency > 0 ? feedFrequency : 1) *
          Number(pre?.duration) >
        0
          ? Number(pre?.duration)
          : 1;
      const reqQty =
        Math.ceil(Number(reqDose) / Number(reqPackValue ?? 0)) ?? 0; //typeof pre?.qty === "undefined" ? 1 : Number(pre?.qty),
      const reqObj = {
        administered: false,
        type: pre?.type ?? null,
        stockId: pre?.stockId,
        batchId: btchDet?.batchId ?? null,
        name: pre?.plName,
        dosage: Number(pre?.dosage) > 0 ? pre?.dosage : "1",
        duration: pre?.duration ?? "1",
        route: pre?.route?.value ?? null,
        meal: pre?.meal,
        quantity: reqQty,
        subUnit: "Unit",
        morning:
          (reqFreqList?.length > 0 && reqFreqList?.includes("morning")) ??
          // && !pre?.frequency?.includes("Custom")
          false,
        afternoon:
          (reqFreqList?.length > 0 && reqFreqList?.includes("afternoon")) ??
          //  && !pre?.frequency?.includes("Custom")
          false,
        night:
          (reqFreqList?.length > 0 && reqFreqList?.includes("night")) ??
          // &&!pre?.frequency?.includes("Custom")
          false,
        adminChargeAmount: 0,
        adminCharge: "N",
        percentage: false,
        delete: false,
        discontinued: "N",
        detailId: pre?.detailId ?? null,
        remark: pre?.remark ?? "",
        drugSchedule: selStock?.drugSchedule ?? null,
        hsnSacCode: selStock?.hsnSacCode ?? null,
        packageUom: btchDet?.salesUom ?? null,
        expiryDate: btchDet?.expiryDate ?? null,
        batchNo: btchDet?.batchNo ?? null,
      };
      const taxPercent =
        clinicDet?.pharmacyTaxId?.length > 0
          ? (btchDet?.cgst ? Number(btchDet?.cgst) : 0) +
            (btchDet?.sgst ? Number(btchDet?.sgst) : 0)
          : 0;
      const reqPercent = 100 + Number(taxPercent);
      const unitPrice =
        (btchDet?.unitSellingPrice ? Number(btchDet?.unitSellingPrice) : 0) /
        (reqPercent / 100);
      const taxValue =
        Number(
          (btchDet?.unitSellingPrice ? Number(btchDet?.unitSellingPrice) : 0) -
            Number(unitPrice),
        ) ?? 0;
      reqObj.price = btchDet?.unitSellingPrice ?? 0;
      reqObj.mrpPrice = btchDet?.unitSellingPrice
        ? Number(btchDet?.unitSellingPrice)
        : 0;
      reqObj.mrpDiscount = 0;
      reqObj.tax = Number(taxValue) * reqQty;
      reqObj.total =
        (btchDet?.unitSellingPrice ? Number(btchDet?.unitSellingPrice) : 0) *
          Number(reqQty) ?? 0;
      reqObj.frequencyDuration = reqFreqList ?? [];
      // if (typeof pre?.frequency === "string") {
      //   reqObj.frequencyDuration = pre?.frequency;
      // }
      if (pre?.productId) reqObj.productId = pre?.productId;
      if (pre?.serviceId) reqObj.serviceId = pre?.serviceId;
      return reqObj;
    });
    const data = {
      status: "Pending",
      remark: procedValues?.notes ?? "",
      prescription: reqPres,
      issue: "",
      paymentId: reqDet?.paymentId ?? null,
    };
    if (reqDet?.prescription?.[0]?.prescriptionId) {
      dispatch(
        updatePrescriptionByIdWoLoader({
          prescriptionId: reqDet?.prescription?.[0]?.prescriptionId,
          data,
        }),
      ).then((res) => {
        if (res?.payload) {
          onCloseFileMod();
          onApiCall();
        }
      });
    } else {
      dispatch(
        createPrescriptionWoLoader({
          appointmentId: appDet?.appointmentId,
          data,
        }),
      ).then((res) => {
        if (res?.payload) {
          onCloseFileMod();
          onApiCall();
        }
      });
    }
  };

  const handleEditPresItem = (ind) => {
    const reqObj = { ...procedValues };
    reqObj.presList = procedValues?.presList?.map((pl, i) => {
      if (pl?.i === ind) return { ...pl, isEdit: true };
      return pl;
    }, []);
    setProcedValues(reqObj);
  };

  const onCloseConMod = () => {
    setConStatusVsble(false);
    setConsumValues({});
  };

  const onCloseAdmUpdteMod = () => {
    setAdmUpdteModVsble(false);
    setAdminValues({});
  };

  const onChangeAdminStatusValue = (name, value) => {
    setAdminValues({ ...adminValues, [name]: value });
  };

  const onChangeConStatusValue = (name, value) => {
    setConsumValues({ ...consumValues, [name]: value });
  };

  const handleSaveConsumStatus = () => {
    const reqObj = { ...procedValues };
    reqObj.consumList = procedValues?.consumList?.map((li, i) => {
      if (li?.i === consumValues?.i) {
        const reqObj = { ...li, reason: consumValues?.reason, status: false };
        addUpdateConsumItems(reqObj);
        return reqObj;
      }
      return li;
    });
    setProcedValues(reqObj);
    onCloseConMod();
  };

  const handleSaveAdminStatus = () => {
    const reqObj = { ...procedValues };
    reqObj.adminList = procedValues?.adminList?.map((li, i) => {
      if (li?.i === adminValues?.i) {
        const reqObj = {
          ...li,
          reason: adminValues?.reason,
          status: false,
          nextDosage: adminValues?.nextDosage,
          nextDueDate: adminValues?.nextDueDate,
        };
        addUpdateAdminItems(reqObj);
        return reqObj;
      }
      return li;
    });
    setProcedValues(reqObj);
    onCloseAdmMod();
  };

  const onCloseAdmMod = () => {
    setAdmStatusVsble(false);
    setAdminValues({});
  };

  const onCloseNoteMod = () => {
    setNotesModVsble(false);
    setNotes("");
  };

  const onSaveNotes = () => {
    dispatch(
      updateNoteByAppointmentIdWoLoader({
        id: appDet?.appointmentId,
        note: notes,
        remarks: appDet?.remarks,
      }),
    ).then((res) => {
      if (res?.payload) {
        onApiCall();
        onCloseNoteMod();
      }
    });
  };

  const onSaveAdminValues = () => {
    const reqObj = { ...procedValues };
    reqObj.adminList = procedValues?.adminList?.map((li, i) => {
      if (li?.i === adminValues?.i) {
        addUpdateAdminItems(adminValues);
        return { ...adminValues, isEdit: false };
      }
      return li;
    });
    setProcedValues(reqObj);
    onCloseAdmUpdteMod();
  };

  const onChangeAdminModValue = (name, value, addObj) => {
    const reqObj = { ...adminValues, [name]: value };
    if (name === "name" && addObj) {
      reqObj.type = addObj?.type;
      reqObj.stockId = addObj?.stockId;
      if (!adminValues?.dosage && addObj?.stockId) {
        const reqBatch = clinicStocks?.find(
          (stc) => stc?.stockId === addObj?.stockId,
        )?.stockBatch?.[0];
        reqObj.batchNumber = {
          name: reqBatch?.batchNo,
          value: reqBatch?.batchId,
        };
      }
      if (adminValues?.dosage) {
        if (addObj?.stockId) {
          const reqBatch = clinicStocks?.find(
            (stc) => stc?.stockId === addObj?.stockId,
          )?.stockBatch?.[0];
          const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
          const priceRatio =
            Number(adminValues?.dosage ?? 0) / Number(reqPack?.[1]);
          const reqPrice =
            (Number(reqBatch?.unitSellingPrice) ?? 0) * Number(priceRatio ?? 0);
          reqObj.batchId = reqBatch?.batchId;
          reqObj.estCost = reqPrice;
          reqObj.batchNumber = {
            name: reqBatch?.batchNo,
            value: reqBatch?.batchId,
          };
        }
      }
    }
    if (name === "batchNumber") {
      const reqBatch = getBatch(
        adminValues?.stockId,
        value?.value ?? adminValues?.batchId,
      );
      const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
      const priceRatio =
        Number(adminValues?.dosage ?? 0) / Number(reqPack?.[1]);
      const reqPrice =
        (Number(reqBatch?.unitSellingPrice) ?? 0) * Number(priceRatio ?? 0);
      reqObj.estCost = value?.value ? reqPrice : 0;
    }
    if (name === "status") {
      if (value) {
        reqObj.reason = "";
      } else {
        reqObj.reason = reasonList?.[0]?.value;
      }
    }
    if (name === "statusDrop") {
      reqObj.status = value;
      if (value) {
        reqObj.reason = "";
      } else {
        reqObj.reason = reasonList?.[0]?.value;
      }
    }
    if (name === "dosage") {
      const reqBatch = getBatch(
        adminValues?.stockId,
        adminValues?.batchNumber?.value ?? adminValues?.batchId,
      );
      const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
      const priceRatio = Number(value) / Number(reqPack?.[1]);
      const reqPrice =
        (Number(reqBatch?.unitSellingPrice) ?? 0) * Number(priceRatio ?? 0);
      reqObj.estCost = reqPrice;
    }
    if (name === "linkToProcedure") {
      reqObj.serviceId = addObj?.serviceId;
      reqObj.variantId = addObj?.variantId;
    }
    setAdminValues(reqObj);
  };

  const handleAdmImageRemove = (ind) => {
    const reqFiles = (adminValues?.files ?? [])?.filter((fl, i) => i !== ind);
    setAdminValues({ ...adminValues, files: reqFiles });
  };

  const onUploadAdmFile = (e) => {
    const fileList = e?.target?.files;
    let fileLists =
      adminValues?.files?.length > 0 ? [...adminValues?.files] : [];
    const readFiles = Array.from(fileList).map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          fileLists = [...fileLists, { file: file, previewUrl: reader.result }];
          resolve();
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
      });
    });
    Promise.all(readFiles)
      .then(() => setAdminValues({ ...adminValues, files: fileLists }))
      .catch((error) => console.error("Error reading files: ", error));
  };

  const onFilesApiCall = async () => {
    if (fileValues?.files?.length === 0 || !fileValues?.files) return;
    dispatch(showLoader());
    const formData = new FormData();
    fileValues?.files?.forEach((file) => {
      formData.append("files", file?.file);
    });
    const res = await soapApi.post("/vaccination", formData);
    if (res?.status === 200) {
      const reqStock = clinicStocks?.filter(
        (li) =>
          li?.tradeName?.toLowerCase() ===
            (res?.data?.TradeName || "").toLowerCase() &&
          li?.stockBatch?.some(
            (bat) =>
              bat?.batchNo?.toLowerCase() ===
              (res?.data?.BatchNumber || "").toLowerCase(),
          ),
      );
      const reqBatch = reqStock?.stockBatch?.find(
        (bat) =>
          bat?.batchNo?.toLowerCase() === res?.data?.BatchNumber?.toLowerCase(),
      );
      const reqObj = {
        name: res?.data?.Name ?? res?.data?.TradeName,
        quantity: 1,
        reason: null,
        deleteable: true,
        isEdit: true,
        estCost: reqStock?.unitSellingPrice ?? 0,
        status: null,
        delete: false,
        serviceId: procedures?.[0]?.service?.serviceId ?? null,
        variantId: procedures?.[0]?.variant?.variantId ?? null,
        linkToProcedure: procedures?.[0]?.service?.name ?? null,
        stockId: reqStock?.stockId ?? null,
        batchId: reqBatch?.batchId ?? null,
        detailId: null,
        dosage: "1",
        route: null,
        isDelete: false,
      };
      if (fileValues?.type === "consumables") {
        addUpdateConsumItems(reqObj);
      }
      if (fileValues?.type === "administer") {
        addUpdateAdminItems(reqObj);
      }
      if (fileValues?.type === "pres") {
        addUpdatePresItems({ ...reqObj, plName: reqObj?.name, duration: "1" });
      }
      dispatch(hideLoader());
    } else {
      dispatch(hideLoader());
    }
  };

  const handleRemoveFile = (ind) => {
    const reqFiles = (fileValues?.files ?? [])
      ?.filter((fl, i) => i !== ind)
      ?.map((li, i) => ({ ...li, i }));
    setFileValues({ ...fileValues, files: reqFiles });
  };

  const onUploadFiles = (e) => {
    const fileList = e?.target?.files;
    let fileLists = fileValues?.files?.length > 0 ? [...fileValues?.files] : [];
    const readFiles = Array.from(fileList).map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          fileLists = [...fileLists, { file: file, previewUrl: reader.result }];
          resolve();
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
      });
    });
    Promise.all(readFiles)
      .then(() => setFileValues({ ...fileValues, files: fileLists }))
      .catch((error) => console.error("Error reading files: ", error));
  };

  const onCloseChangeWarnMod = () => {
    setChangeWarnVsble(false);
    setSelectedProcedure(null);
  };

  const onConfirmChangeWarn = async () => {
    if (selectedProcedure?.type === "delete") {
      if (selectedProcedure?.procedureId) {
        dispatch(
          deleteProcedureByIdWoLoader(selectedProcedure?.procedureId),
        ).then((res) => {
          if (res?.payload) {
            onApiCall();
            onCloseChangeWarnMod();
            return;
          }
        });
      }
    } else {
      if (
        selectedProcedure?.procedureId ??
        selectedProcedure?.service?.procedureId
      ) {
        await dispatch(
          deleteProcedureByIdWoLoader(
            selectedProcedure?.procedureId ??
              selectedProcedure?.service?.procedureId,
          ),
        );
      }
      const procedureDetailsResult = await getProcedureDetailsNew({
        servId:
          selectedProcedure?.serviceId ?? selectedProcedure?.service?.serviceId,
        varntId:
          selectedProcedure?.variantId ?? selectedProcedure?.variant?.variantId,
        services: services ?? [],
        clinicStocks: clinicStocks ?? [],
        pharmacyTaxId: clinicDet?.pharmacyTaxId,
        status: true,
        facilities,
        facilityId: appDet?.facilityId,
        patientWorkbook: true,
        locations: locationList ?? [],
      });
      const procedureDetails = procedureDetailsResult?.procedureDetails;
      if (procedureDetailsResult?.prescriptions?.length > 0) {
        const data = {
          status: "Pending",
          remark: "",
          prescription: procedureDetailsResult?.prescriptions,
          issue: "",
          paymentId: reqDet?.paymentId ?? null,
        };
        if (reqDet?.prescription?.[0]?.prescriptionId) {
          dispatch(
            updatePrescriptionByIdWoLoader({
              prescriptionId: reqDet?.prescription?.[0]?.prescriptionId,
              data,
            }),
          );
        } else {
          dispatch(
            createPrescriptionWoLoader({
              appointmentId: appDet?.appointmentId,
              data,
            }),
          );
        }
      }
      const resServ = services?.find(
        (ser) => ser?.serviceId === selectedProcedure?.service?.serviceId,
      );
      const reqVar = resServ?.serviceVariants?.find(
        (vnt) =>
          vnt?.variantName === getOnlyName(selectedProcedure?.variant?.name),
      );
      let tax = 0;
      let total =
        reqVar?.serviceCharge ?? selectedProcedure?.variant?.serviceCharge ?? 0;
      if (resServ?.taxApplicability?.toLowerCase() === "yes") {
        tax +=
          resServ?.taxApplicability?.toLowerCase() === "yes"
            ? (Number(reqVar?.serviceCharge ?? 0) / 100) *
              Number(resServ?.tax ?? 0)
            : 0;
        total += tax;
      }
      const data = {
        procedureName: selectedProcedure?.service?.name,
        serviceId: selectedProcedure?.service?.serviceId,
        category: selectedProcedure?.service?.category,
        subCategory: selectedProcedure?.service?.subCategory,
        remarks: selectedProcedure?.service?.remarks,
        doneAt: moment(new Date()).format("YYYY-MM-DD"),
        status: "Pending",
        petId: appDet?.petId,
        appointmentId: appDet?.appointmentId,
        serviceCharge: selectedProcedure?.variant?.serviceCharge,
        serviceType: getOnlyName(selectedProcedure?.variant?.name),
        procedureDetails,
        tax: Number(Number(tax) * Number(selectedProcedure?.quantity ?? 1)),
        total: Number(Number(total) * Number(selectedProcedure?.quantity ?? 1)),
        mrpPrice: Number(reqVar?.serviceCharge ?? 0),
        procedureVariantId: selectedProcedure?.variant?.variantId,
        quantity: Number(selectedProcedure?.quantity ?? 1),
        patientWorkbook: true,
        mainProcedure: true,
        paymentId: reqDet?.paymentId ?? null,
      };
      dispatch(createProcedureWoLoader({ data })).then((res) => {
        if (res?.payload) {
          onApiCall();
          onCloseChangeWarnMod();
        }
      });
    }
  };

  const onConfirmDelete = () => {
    if (selectedItem?.type === "procedure") {
      deleteProcedureById(selectedItem?.item?.procedureId);
    }
    if (selectedItem?.type === "procedureDetail") {
      deleteProcedureDetailById(selectedItem?.item?.detailId);
    }
    if (selectedItem?.type === "presDetail") {
      deletePresDetailById(selectedItem?.item?.detailId);
    }
  };

  const handleCreateReminderProcedure = (prcd) => {
    setAddNewProcedValues({
      nextDueDate: new Date(),
      remarks: "",
    });
    setSelectedProcedure(prcd);
    setAddProcedModVsble(true);
  };

  const onCloseAddProcedMod = () => {
    setAddProcedModVsble(false);
    setSelectedProcedure(null);
    setAddNewProcedValues({});
  };

  const handleSaveReminderProcedure = () => {
    const data = {
      doneAt: moment(new Date(addNewProcedValues?.nextDueDate)).format(
        "YYYY-MM-DD",
      ),
      remarks: addNewProcedValues?.remarks,
      procedureDetails: [],
      serviceType: selectedProcedure?.variant?.name,
      isFromPreventive: false,
      procedureVariantId: selectedProcedure?.variant?.variantId,
      procedureName: selectedProcedure?.service?.name,
      serviceId: selectedProcedure?.service?.serviceId,
      category: selectedProcedure?.service?.category,
      subCategory: selectedProcedure?.service?.subCategory,
      petId: appDet?.petId,
      status: "Pending",
      paymentId: reqDet?.paymentId ?? null,
    };
    dispatch(
      createProcedureWoLoader({
        data,
        successMessage: "Reminder added successfully",
      }),
    ).then((res) => {
      if (res?.payload) {
        onCloseAddProcedMod();
        onApiCall();
      }
    });
  };

  const handlePrint = useReactToPrint({
    content: () => contentToPrint.current,
    documentTitle: "",
    pageStyle: a4PrintConfig,
    removeAfterPrint: true,
    onBeforeGetContent: () => {
      printTitleRef.current = document.title;
      document.title = "";
    },
    onAfterPrint: () => {
      document.title = printTitleRef.current ?? "";
    },
  });

  // <div ref={ref} className="print-container">
  //   <div className="header">My Custom Header</div>

  //   <div className="content">{/* Your long content */}</div>

  //   <div className="footer">Page Footer</div>
  // </div>;

  // const ComponentToPrint = React.forwardRef((props, ref) => {
  //   return (
  //     <div ref={ref} className="print-container prescription-print-root">
  //       <table className="prescription-print-layout">
  //         <thead>
  //           <tr>
  //             <td className="prescription-print-thead-cell">
  //               <div className="prescription-print-doc-header">
  //                 <div className="flex-row flex-row-between-align-center w100Per">
  //                   <img alt="" src={clinicDet?.image} className="img-h50" />
  //                   <div className="prescription-doc-header-clinic">
  //                     <div className="font-bold fs12 blue-color">
  //                       Business Name:
  //                     </div>
  //                     <div className="font-medium blue-color fs12">
  //                       {clinicDet?.name ?? ""}
  //                     </div>
  //                     <div className="font-bold fs12 blue-color mt5">
  //                       Business Address:
  //                     </div>
  //                     <div className="txt-regular fs12 blue-color">
  //                       {clinicDet?.address ?? ""}
  //                     </div>
  //                     {clinicDet?.taxId?.length > 0 ? (
  //                       <div className="flex-row-ali-cen mt5">
  //                         <div className="font-bold fs12 blue-color">
  //                           CLINIC TAX ID:{" "}
  //                         </div>
  //                         <div className="txt-regular fs12 blue-color ml3">
  //                           {clinicDet?.taxId ?? ""}
  //                         </div>
  //                       </div>
  //                     ) : null}
  //                     {clinicDet?.mobile?.length > 0 ? (
  //                       <div className="flex-row-ali-cen mt5">
  //                         <div className="font-bold fs12 blue-color">
  //                           Contact:{" "}
  //                         </div>
  //                         <div className="txt-regular fs12 blue-color ml3">
  //                           {clinicDet?.mobile ?? ""}
  //                         </div>
  //                       </div>
  //                     ) : null}
  //                   </div>
  //                 </div>
  //               </div>
  //             </td>
  //           </tr>
  //         </thead>
  //         <tbody>
  //           <tr>
  //             <td className="prescription-print-tbody-cell">
  //               <div className="prescription-print-body-inner">
  //                 <div className="prescription-print-top-block">
  //                   <div className="flex-center mb20 font-bold blue-color fs18 prescription-print-hide-in-pdf">
  //                     Prescription
  //                   </div>

  //                   <div className="flex-end mb10">
  //                     <img alt="" src={clinicDet?.image} className="img-h50" />
  //                   </div>
  //                 </div>

  //                 <div className="p5">
  //                   <div className="blue-box-examD">
  //                     <div className="flex-row prescription-print-patient-block">
  //                       <div className="w65Per">
  //                         <div className="flex-column">
  //                           <div className="flex-row mv5">
  //                             {appDet?.petType?.length > 0 ? (
  //                               <>
  //                                 <div className="font-bold fs12 blue-color">
  //                                   Pet Name:
  //                                 </div>
  //                                 <div className="font-bold fs12 black capitalize ml5">
  //                                   {appDet?.petName}
  //                                 </div>
  //                               </>
  //                             ) : null}
  //                             {appDet?.petType?.length > 0 ? (
  //                               <>
  //                                 <div className="font-bold fs12 blue-color ml15">
  //                                   Species:
  //                                 </div>
  //                                 <div className="txt-regular fs12 black capitalize ml5">
  //                                   {appDet?.petType}
  //                                 </div>
  //                               </>
  //                             ) : null}
  //                             {appDet?.breed?.length > 0 ? (
  //                               <>
  //                                 <div
  //                                   className={`font-bold fs12 blue-color ${appDet?.petType?.length > 0 ? "ml15" : ""}`}
  //                                 >
  //                                   Breed:
  //                                 </div>
  //                                 <div className="txt-regular fs12 black capitalize ml5">
  //                                   {appDet?.breed}
  //                                 </div>
  //                               </>
  //                             ) : null}
  //                           </div>
  //                           <div className="flex-row mv5">
  //                             {genderEnum?.[appDet?.gender]?.length > 0 ? (
  //                               <>
  //                                 <div className="font-bold fs12 blue-color">
  //                                   Gender:
  //                                 </div>
  //                                 <div className="txt-regular fs12 black capitalize ml5">
  //                                   {genderEnum?.[appDet?.gender]}
  //                                 </div>
  //                               </>
  //                             ) : null}
  //                             {appDet?.weight?.length > 0 ? (
  //                               <>
  //                                 <div
  //                                   className={`font-bold fs12 blue-color ${genderEnum?.[appDet?.gender]?.length > 0 ? "ml15" : ""}`}
  //                                 >
  //                                   Weight:
  //                                 </div>
  //                                 <div className="txt-regular fs12 black capitalize ml5">
  //                                   {appDet?.weight} Kg
  //                                 </div>
  //                               </>
  //                             ) : null}
  //                             {appDet?.dob?.length > 0 ? (
  //                               <>
  //                                 <div
  //                                   className={`font-bold fs12 blue-color ${genderEnum?.[appDet?.gender]?.length > 0 ? "ml15" : ""}`}
  //                                 >
  //                                   Age:
  //                                 </div>
  //                                 <div className="txt-regular fs12 black capitalize ml5">
  //                                   {moment(new Date(appDet?.dob))?.fromNow(
  //                                     true,
  //                                   )}
  //                                 </div>
  //                               </>
  //                             ) : null}
  //                           </div>
  //                           <div className="flex-row mv5">
  //                             <div className="font-bold fs12 blue-color">
  //                               Customer:
  //                             </div>
  //                             <div className="font-bold fs12 black capitalize ml5">
  //                               {appDet?.userName}
  //                             </div>
  //                           </div>
  //                           {appDet?.address?.length > 0 ? (
  //                             <div className="flex-row mv5">
  //                               <div className="w40Per">
  //                                 <div className="font-bold fs12 blue-color">
  //                                   Address:
  //                                 </div>
  //                                 <div className="txt-regular fs12 black capitalize ml5">
  //                                   {appDet?.address}
  //                                 </div>
  //                               </div>
  //                             </div>
  //                           ) : null}
  //                         </div>
  //                       </div>
  //                       <div className="w35Per">
  //                         <div className="flex-column">
  //                           <div className="flex-row mt10">
  //                             <div className="font-bold fs12 blue-color">
  //                               Vet Name:
  //                             </div>
  //                             <div className="font-bold fs12 black ml5 capitalize">
  //                               {`${getRightSaluation(clinicVets, appDet?.doctorId)}${
  //                                 appDet?.doctorName ?? ""
  //                               }`}
  //                             </div>
  //                             {appDet?.registrationNo?.length > 0 ? (
  //                               <div className="flex-row-ali-cen">
  //                                 <div className="font-regular fs12 black ml5">
  //                                   (
  //                                 </div>
  //                                 <div className="font-bold fs12 blue-color ml2">
  //                                   RegNo:
  //                                 </div>
  //                                 <div className="font-regular fs12 black ml5 capitalize">
  //                                   {appDet?.registrationNo} )
  //                                 </div>
  //                               </div>
  //                             ) : (
  //                               ""
  //                             )}
  //                           </div>
  //                           <div className="flex-row mv5">
  //                             <div className="font-bold fs12 blue-color">
  //                               Date:
  //                             </div>
  //                             <div className="txt-regular fs12 black ml5">
  //                               {moment(
  //                                 new Date(appDet?.appointmentDate),
  //                               ).format("DD MMM YYYY")}
  //                             </div>
  //                           </div>
  //                         </div>
  //                       </div>
  //                       {/* <div className="w25Per">
  //                   <div className="flex-end">
  //                     <img alt="" src={clinicDet?.image} className="img-h50" />
  //                   </div>
  //                 </div> */}
  //                     </div>
  //                     <div className="box-hor-split mv10" />
  //                     <PrescriptionView prescriptions={reqDet?.presList} />
  //                     {/* {getListDataToShow()} */}
  //                     {/* <div className="flex-row mv20">
  //                 <img
  //                   src={require("../../../../assets/images/jpg/WoofQrCode.jpeg")}
  //                   alt=""
  //                   className="img-h50"
  //                 />
  //                 <div className="blu-back wh50 flex-center">
  //                   <img
  //                     src={require("../../../../assets/images/png/VetInstantLogo.png")}
  //                     alt=""
  //                     className="img-h40"
  //                   />
  //                 </div>
  //                 <div className="flex-center">
  //                   <div className="font-bold fs14 ml20">
  //                     Scan to download our app
  //                   </div>
  //                 </div>
  //               </div> */}
  //                   </div>
  //                 </div>
  //               </div>
  //             </td>
  //           </tr>
  //         </tbody>
  //       </table>
  //       <div className="prescription-print-doc-footer prescription-print-footer-pin">
  //         <img
  //           src={require("../../../../assets/images/png/cropped_footer.png")}
  //           alt=""
  //         />
  //       </div>
  //     </div>
  //   );
  // });

  return (
    <>
      <div>
        <div className="flex-row mh10 mt20">
          <div className="w20Per">
            <Typography className="txt-semi-bold fs12 blue-color">
              Procedure Name
            </Typography>
          </div>
          <div className="w15Per">
            <Typography className="txt-semi-bold fs12 blue-color">
              Variant
            </Typography>
          </div>
          <div className="w10Per">
            <Typography className="txt-semi-bold fs12 blue-color">
              Qty
            </Typography>
          </div>
          <div className="w15Per">
            <Typography className="txt-semi-bold fs12 blue-color">
              Category
            </Typography>
          </div>
          <div className="w15Per">
            <Typography className="txt-semi-bold fs12 blue-color">
              Subcategory
            </Typography>
          </div>
          <div className="w15Per">
            <Typography className="txt-semi-bold fs12 blue-color">
              Bundled Selling Price
            </Typography>
          </div>
          <div className="w10Per" />
        </div>
        <div className="blue-hor-split mt5" />
        {procedures?.map((prcd, index) => {
          return (
            <div
              className="flex-row mt10 plan-bor"
              key={`procedure_${prcd?.procedureId ?? index}`}
            >
              <div className="w20Per pr10">
                <CustomSelect
                  list={getServiceList()}
                  value={prcd?.service?.name}
                  handleChange={(value) => onChange("service", value, prcd?.i)}
                  error={prcd?.servErr}
                  helperText={prcd?.servErr ? reqTxt : ""}
                  addNewSelect
                  searchOnly
                  disabled={!prcd?.editable}
                />
              </div>
              <div className="w15Per pr10">
                <CustomSelect
                  list={getVarinatList(prcd?.service?.serviceId)}
                  value={prcd?.variant?.name}
                  select
                  handleChange={(e) => {
                    onChange(
                      "variant",
                      getVarinatList(prcd?.service?.serviceId)?.find(
                        (li) => li?.name === e?.target?.value,
                      ),
                      prcd?.i,
                      prcd?.variantId,
                    );
                  }}
                  error={prcd?.varErr}
                  helperText={prcd?.varErr ? reqTxt : ""}
                  disabled={!prcd?.editable}
                />
              </div>
              <div className="w10Per pr10">
                <CustomTextField
                  value={prcd?.quantity}
                  handleChange={(e) => {
                    onChange("quantity", e?.target?.value, prcd?.i);
                  }}
                  fullWidth
                  error={prcd?.qtyErr}
                  helperText={prcd?.qtyErr ? reqTxt : ""}
                  disabled={!prcd?.editable}
                  type="number"
                />
              </div>
              <div className="w15Per pr10">
                <Custom3dotString
                  str={prcd?.service?.category}
                  className="font-medium fs12 mt10"
                  length={13}
                />
              </div>
              <div className="w15Per pr10">
                <Custom3dotString
                  str={prcd?.service?.subCategory}
                  className="font-medium fs12 mt10"
                  length={13}
                />
              </div>
              <div className="w15Per">
                <Typography className="font-medium fs12 mt10">
                  Rs. {Number(prcd?.variant?.servicePrice ?? 0)?.toFixed(2)}
                </Typography>
              </div>
              <div className="w10Per">
                {appDet?.appointmentStatus?.toLowerCase() !== "completed" ? (
                  <div className="flex1-end mt3">
                    <div className="flex-row-ali-cen">
                      {!prcd?.editable ? (
                        <div
                          className="cursor"
                          onClick={() => handleCreateReminderProcedure(prcd)}
                        >
                          <div className="flex-center">
                            <EditCalendarIcon sx={edtBtn} />
                          </div>
                          <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                            Add
                          </Typography>
                        </div>
                      ) : null}
                      {prcd?.editable ? (
                        <div
                          className="cursor"
                          onClick={() => createUpdateProcedure(prcd)}
                        >
                          <div className="flex-center">
                            <SaveIcon sx={edtBtn} />
                          </div>
                          <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                            Save
                          </Typography>
                        </div>
                      ) : null}
                      {/* {!prcd?.editable ? ( */}
                      <div
                        className="cursor ml10"
                        onClick={() => delProcedure(prcd?.i)}
                      >
                        <div className="flex-center">
                          <DeleteOutlineIcon sx={delBtn} />
                        </div>
                        <Typography className="red3 fs8 txt-semi-bold text-align-center">
                          Delete
                        </Typography>
                      </div>
                      {/* ) : null} */}
                      {!prcd?.editable && (
                        <div
                          className="cursor ml10"
                          onClick={() => handleEditProcedure(prcd?.i)}
                        >
                          <div className="flex-center">
                            <EditIcon sx={edtBtn} />
                          </div>
                          <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                            Edit
                          </Typography>
                        </div>
                      )}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          );
        })}
        {appDet?.appointmentStatus?.toLowerCase() !== "completed" ? (
          <div className="flex-row-ali-cen mt10 cursor" onClick={addProcedure}>
            <div className="flex-center plus-icon">
              <AddIcon sx={addIcon} />
            </div>
            <Typography className="blue-color fs16 ml5 font-bold">
              Add
            </Typography>
          </div>
        ) : null}
        {reqDet?.procedures?.length > 0 ? (
          <>
            <Card sx={cardSty} className="mt20">
              <div
                className="flex-row-ali-cen cursor"
                onClick={() => handleObjOpen("consum", !objOpen?.consum)}
              >
                {objOpen?.consum ? (
                  <ArrowDropDownIcon sx={cardIcon} />
                ) : (
                  <ArrowRightIcon sx={cardIcon} />
                )}
                <div className="flex-row-ali-cen">
                  <Typography className="font-bold fs14 blue-color">
                    Consumables
                  </Typography>
                </div>
              </div>
              {objOpen?.consum ? (
                <div className="flex-column">
                  <div className="flex-row-ali-cen mh10">
                    <div className="w30Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Name
                      </Typography>
                    </div>
                    <div className="w20Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Batch Number
                      </Typography>
                    </div>
                    <div className="w10Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Qty
                      </Typography>
                    </div>
                    <div className="w20Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Link to Procedure
                      </Typography>
                    </div>
                    <div className="w10Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Status
                      </Typography>
                    </div>
                    {/* <div className="w10Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Reason
                      </Typography>
                    </div> */}

                    <div className="w10Per" />
                  </div>
                  <div className="blue-hor-split mt5" />
                  {procedValues?.consumList
                    ?.filter((li) => !li?.isDelete)
                    ?.map((li, i) => {
                      return (
                        <div
                          className="flex-row mt10 plan-bor"
                          key={`${li?.i}_consum`}
                        >
                          <div className="w30Per pr10">
                            <CustomSelect
                              list={
                                li?.fromService
                                  ? getDropList(li)
                                  : getList(false)
                              }
                              value={li?.name}
                              addNewSelect
                              searchOnly
                              handleChange={(e) => {
                                onChangeConsumValue(
                                  "name",
                                  e?.value ?? e,
                                  li?.i,
                                  {
                                    stockId: e?.stockId ?? null,
                                    productId: e?.productId ?? null,
                                    serviceId: e?.serviceId ?? null,
                                    type: e?.type,
                                  },
                                );
                              }}
                              plusBtn
                              disabled={!li?.isEdit}
                              isForProcedure
                            />
                          </div>
                          <div className="w20Per pr10">
                            <CustomSelect
                              list={getBatches(li?.stockId)}
                              value={li?.batchNumber}
                              handleChange={(e, value) => {
                                onChangeConsumValue(
                                  "batchNumber",
                                  value,
                                  li?.i,
                                );
                              }}
                              name="batchNumber"
                              search
                              isBatchNumber
                              disabled={
                                !li?.isEdit ||
                                getBatch(li?.stockId, null, true)?.autoConsumed
                              }
                            />
                          </div>
                          <div className="w10Per pr10">
                            <CustomTextField
                              value={li?.quantity}
                              type="number"
                              fullWidth
                              handleChange={(e) =>
                                onChangeConsumValue(
                                  "quantity",
                                  e?.target?.value,
                                  li?.i,
                                )
                              }
                              disabled={!li?.isEdit}
                            />
                          </div>
                          <div className="w20Per pr10">
                            <CustomSelect
                              list={getProcedureListAsDrop()}
                              value={li?.linkToProcedure}
                              // select
                              search
                              handleChange={(e, value) => {
                                // const reqPrcd = getProcedureListAsDrop()?.find(
                                //   (li) => li?.name === e?.target?.value,
                                // );
                                onChangeConsumValue(
                                  "linkToProcedure",
                                  value,
                                  li?.i,
                                  {
                                    serviceId: value?.serviceId ?? null,
                                    variantId: value?.variantId ?? null,
                                  },
                                );
                              }}
                              disabled={!li?.deleteable || !li?.isEdit}
                            />
                          </div>
                          <div className="w10Per pr10">
                            {li?.isRejected ||
                            li?.isRequested ||
                            li?.isIssued ||
                            li?.status ? (
                              <Typography
                                className={`${
                                  li?.isRequested
                                    ? "orange-back2"
                                    : li?.isRejected || li?.status === false
                                      ? "red-back2"
                                      : li?.isIssued || li?.status === true
                                        ? "green-back5"
                                        : ""
                                } white-color status-con fs12 font-medium mt10`}
                              >
                                {li?.isRequested
                                  ? "Requested"
                                  : li?.isRejected
                                    ? "Rejected"
                                    : li?.isIssued
                                      ? "Issued"
                                      : li?.status === true
                                        ? "Completed"
                                        : li?.status === false
                                          ? "Not Done"
                                          : ""}
                              </Typography>
                            ) : null}
                          </div>
                          <div className="w10Per align-center-wh">
                            {appDet?.appointmentStatus?.toLowerCase() !==
                            "completed" ? (
                              <div className="flex-row-ali-cen">
                                {(li?.stockId
                                  ? getBatch(li?.stockId, null, true)
                                      ?.autoConsumed ||
                                    li?.batchNumber?.value ||
                                    li?.batchId ||
                                    li?.isIssued
                                  : li?.isIssued) && li?.isEdit ? (
                                  <div className="flex-row-ali-cen align-center-wh">
                                    {/* <div
                                      className="cursor"
                                      onClick={() =>
                                        onChangeConsumValue(
                                          "status",
                                          true,
                                          li?.i,
                                        )
                                      }
                                    >
                                      <div className="flex-center">
                                        <SaveIcon sx={edtBtn} />
                                      </div>
                                      <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                                        Save
                                      </Typography>
                                    </div> */}
                                    <div
                                      className="cursor ml10"
                                      onClick={() => handleConsumDelete(li?.i)}
                                    >
                                      <div className="flex-center">
                                        <DeleteOutlineIcon sx={delBtn} />
                                      </div>
                                      <Typography className="red3 fs8 txt-semi-bold text-align-center">
                                        Delete
                                      </Typography>
                                    </div>
                                  </div>
                                ) : li?.deleteable && !li?.isEdit ? (
                                  <div
                                    className="cursor"
                                    onClick={() => handleConsumDelete(li?.i)}
                                  >
                                    <div className="flex-center">
                                      <DeleteOutlineIcon sx={delBtn} />
                                    </div>
                                    <Typography className="red3 fs8 txt-semi-bold text-align-center">
                                      Delete
                                    </Typography>
                                  </div>
                                ) : (
                                  <div
                                    className="cursor"
                                    onClick={() => handleConsumDelete(li?.i)}
                                  >
                                    <div className="flex-center">
                                      <DeleteOutlineIcon sx={delBtn} />
                                    </div>
                                    <Typography className="red3 fs8 txt-semi-bold text-align-center">
                                      Delete
                                    </Typography>
                                  </div>
                                )}
                                {!li?.isEdit && !li?.isRejected ? (
                                  <div
                                    className="cursor ml10"
                                    onClick={() => handleConsumEdit(li?.i)}
                                  >
                                    <div className="flex-center">
                                      <EditIcon sx={edtBtn} />
                                    </div>
                                    <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                                      Edit
                                    </Typography>
                                  </div>
                                ) : null}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      );
                    })}
                  {appDet?.appointmentStatus?.toLowerCase() !== "completed" ? (
                    <div className="flex-row-ali-cen mt20">
                      <div
                        className="flex-row-ali-cen cursor"
                        onClick={addNewConsumable}
                      >
                        <div className="flex-center plus-icon">
                          <AddIcon sx={addIcon} />
                        </div>
                        <Typography className="blue-color fs16 ml5 font-bold">
                          Add
                        </Typography>
                      </div>
                      {/* <div
                        className="flex-row-ali-cen cursor ml20"
                        onClick={() => onAddFiles("consumables")}
                      >
                        <div className="flex-center plus-icon">
                          <AddIcon sx={addIcon} />
                        </div>
                        <Typography className="blue-color fs16 ml5 font-bold">
                          Add From File
                        </Typography>
                      </div> */}

                      {procedValues?.consumList?.length > 0 &&
                      procedValues?.consumList?.some((li) => li?.isEdit) ? (
                        <div className="ml20">
                          <CustomButton
                            text="Save"
                            smallBtn
                            onClick={onSaveMultiConsums}
                          />
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                </div>
              ) : null}
            </Card>

            <Card sx={cardSty} className="mt20">
              <div
                className="flex-row-ali-cen cursor"
                onClick={() => handleObjOpen("admin", !objOpen?.admin)}
              >
                {objOpen?.admin ? (
                  <ArrowDropDownIcon sx={cardIcon} />
                ) : (
                  <ArrowRightIcon sx={cardIcon} />
                )}
                <div className="flex-row-ali-cen">
                  <Typography className="font-bold fs14 blue-color">
                    Administer
                  </Typography>
                </div>
              </div>
              {objOpen?.admin ? (
                <div style={{ overflowX: "auto", width: "100%" }}>
                  <div style={{ minWidth: 1090 }}>
                    <div className="flex-column">
                      <div className="flex-row-ali-cen mh10">
                        <div style={{ width: 220 }}>
                          <Typography className="txt-semi-bold fs12 blue-color">
                            Name
                          </Typography>
                        </div>
                        <div style={{ width: 220 }}>
                          <Typography className="txt-semi-bold fs12 blue-color">
                            Batch Number
                          </Typography>
                        </div>
                        <div style={{ width: 120 }}>
                          <Typography className="txt-semi-bold fs12 blue-color">
                            Qty
                          </Typography>
                        </div>
                        <div style={{ width: 150 }}>
                          <Typography className="txt-semi-bold fs12 blue-color">
                            Dosage
                          </Typography>
                        </div>
                        <div style={{ width: 150 }}>
                          <Typography className="txt-semi-bold fs12 blue-color">
                            Route
                          </Typography>
                        </div>
                        <div style={{ width: 150 }}>
                          <Typography className="txt-semi-bold fs12 blue-color">
                            Link to Procedure
                          </Typography>
                        </div>
                        <div style={{ width: 100 }}>
                          <Typography className="txt-semi-bold fs12 blue-color">
                            Status
                          </Typography>
                        </div>
                        <div style={{ width: 100 }} />
                      </div>
                      <div className="blue-hor-split mt5" />
                      {procedValues?.adminList
                        ?.filter((li) => !li?.isDelete)
                        ?.map((li, i) => {
                          return (
                            <div
                              className="flex-row mt10 plan-bor"
                              key={`${i}_admin`}
                            >
                              <div style={{ width: 220 }} className="pr10">
                                <CustomSelect
                                  list={
                                    li?.fromService
                                      ? getDropList(li)
                                      : getList(true)
                                  }
                                  value={li?.name}
                                  addNewSelect
                                  mandatoryField
                                  handleChange={(e) => {
                                    onChangeAdminValue(
                                      "name",
                                      e?.value ?? e,
                                      li?.i,
                                      {
                                        stockId: e?.stockId ?? null,
                                        productId: e?.productId ?? null,
                                        serviceId: e?.serviceId ?? null,
                                        type: e?.type,
                                      },
                                    );
                                  }}
                                  plusBtn
                                  disabled={!li?.isEdit}
                                  isForProcedure
                                />
                              </div>
                              <div style={{ width: 220 }} className="pr10">
                                <CustomSelect
                                  list={getBatches(li?.stockId)}
                                  value={li?.batchNumber}
                                  handleChange={(e, value) => {
                                    onChangeAdminValue(
                                      "batchNumber",
                                      value,
                                      li?.i,
                                    );
                                  }}
                                  name="batchNumber"
                                  search
                                  isBatchNumber
                                  disabled={
                                    !li?.isEdit ||
                                    getBatch(li?.stockId, null, true)
                                      ?.autoConsumed
                                  }
                                />
                              </div>
                              <div style={{ width: 120 }} className="pr10">
                                <CustomTextField
                                  fullWidth
                                  handleChange={(e) =>
                                    onChangeAdminValue(
                                      "quantity",
                                      e?.target?.value,
                                      li?.i,
                                    )
                                  }
                                  value={li?.quantity}
                                  type="number"
                                  disabled={
                                    !li?.isEdit
                                    // ||
                                    // (!li?.batchNumber?.value && !li?.batchId)
                                  }
                                />
                              </div>
                              <div style={{ width: 150 }} className="pr10">
                                <CustomTextField
                                  fullWidth
                                  handleChange={(e) =>
                                    onChangeAdminValue(
                                      "dosage",
                                      e?.target?.value,
                                      li?.i,
                                    )
                                  }
                                  value={li?.dosage}
                                  suffix={
                                    getRightPackageUom(
                                      getBatch(
                                        li?.stockId,
                                        li?.batchNumber?.value ?? li?.batchId,
                                      )?.packageUom,
                                      true,
                                    )?.length > 0 ? (
                                      <Custom3dotString
                                        str={`${getRightPackageUom(
                                          getBatch(
                                            li?.stockId,
                                            li?.batchNumber?.value ??
                                              li?.batchId,
                                          )?.packageUom,
                                          true,
                                        )}`}
                                        length={9}
                                        className="fs12 font-medium"
                                        capitalize={false}
                                      />
                                    ) : (
                                      ""
                                    )
                                  }
                                  type="number"
                                  disabled={
                                    !li?.isEdit
                                    // ||
                                    // (!li?.batchNumber?.value && !li?.batchId)
                                  }
                                />
                              </div>
                              <div style={{ width: 150 }} className="pr10">
                                <CustomSelect
                                  list={routeList}
                                  value={li?.route}
                                  search
                                  handleChange={(e, value) => {
                                    onChangeAdminValue("route", value, li?.i);
                                  }}
                                  disabled={!li?.isEdit}
                                />
                              </div>
                              <div style={{ width: 150 }} className="pr10">
                                <CustomSelect
                                  list={getProcedureListAsDrop()}
                                  value={li?.linkToProcedure}
                                  // select
                                  search
                                  handleChange={(e, value) => {
                                    // const reqPrcd =
                                    //   getProcedureListAsDrop()?.find(
                                    //     (li) => li?.name === e?.target?.value,
                                    //   );
                                    onChangeAdminValue(
                                      "linkToProcedure",
                                      value,
                                      li?.i,
                                      {
                                        serviceId: value?.serviceId ?? null,
                                        variantId: value?.variantId ?? null,
                                      },
                                    );
                                  }}
                                  disabled={!li?.deleteable || !li?.isEdit}
                                />
                              </div>
                              <div style={{ width: 100 }} className="pr10">
                                {typeof li?.status === "boolean" ? (
                                  <Typography
                                    className={`${
                                      li?.status ? "green-back5" : "red-back2"
                                    } white-color status-con fs12 font-medium mt10`}
                                  >
                                    {li?.status ? "Completed" : "Not Done"}
                                  </Typography>
                                ) : li?.isRejected ||
                                  li?.isRequested ||
                                  li?.isIssued ? (
                                  <Typography
                                    className={`${
                                      li?.isRequested
                                        ? "orange-back2"
                                        : li?.isRejected
                                          ? "red-back2"
                                          : li?.isIssued
                                            ? "green-back5"
                                            : ""
                                    } white-color status-con fs12 font-medium mt10`}
                                  >
                                    {li?.isRequested
                                      ? "Requested"
                                      : li?.isRejected
                                        ? "Rejected"
                                        : li?.isIssued
                                          ? "Issued"
                                          : ""}
                                  </Typography>
                                ) : null}
                              </div>
                              <div
                                style={{ width: 100 }}
                                className="align-center-wh"
                              >
                                {appDet?.appointmentStatus?.toLowerCase() !==
                                "completed" ? (
                                  <div className="flex-row-ali-cen">
                                    {(li?.stockId
                                      ? getBatch(li?.stockId, null, true)
                                          ?.autoConsumed ||
                                        li?.batchNumber?.value ||
                                        li?.batchId ||
                                        li?.isIssued
                                      : li?.isIssued) && li?.isEdit ? (
                                      <div className="flex-row-ali-cen">
                                        {/* <div
                                          className="cursor"
                                          onClick={() =>
                                            onChangeAdminValue(
                                              "status",
                                              true,
                                              li?.i,
                                            )
                                          }
                                        >
                                          <div className="flex-center">
                                            <SaveIcon sx={edtBtn} />
                                          </div>
                                          <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                                            Save
                                          </Typography>
                                        </div> */}
                                        <div
                                          className="cursor ml10"
                                          onClick={() =>
                                            handleAdminDelete(li?.i)
                                          }
                                        >
                                          <div className="flex-center">
                                            <DeleteOutlineIcon sx={delBtn} />
                                          </div>
                                          <Typography className="red3 fs8 txt-semi-bold text-align-center">
                                            Delete
                                          </Typography>
                                        </div>
                                      </div>
                                    ) : li?.deleteable && !li?.isEdit ? (
                                      <div
                                        className="cursor"
                                        onClick={() => handleAdminDelete(li?.i)}
                                      >
                                        <div className="flex-center">
                                          <DeleteOutlineIcon sx={delBtn} />
                                        </div>
                                        <Typography className="red3 fs8 txt-semi-bold text-align-center">
                                          Delete
                                        </Typography>
                                      </div>
                                    ) : (
                                      <div
                                        className="cursor"
                                        onClick={() => handleAdminDelete(li?.i)}
                                      >
                                        <div className="flex-center">
                                          <DeleteOutlineIcon sx={delBtn} />
                                        </div>
                                        <Typography className="red3 fs8 txt-semi-bold text-align-center">
                                          Delete
                                        </Typography>
                                      </div>
                                    )}
                                    {!li?.isEdit && !li?.isRejected ? (
                                      // !li?.isEdit &&
                                      // (li?.batchNumber?.value ||
                                      //   li?.batchId ||
                                      //   li?.isRequested)
                                      <div
                                        className="cursor ml10"
                                        onClick={() => handleAdminEdit(li?.i)}
                                      >
                                        <div className="flex-center">
                                          <EditIcon sx={edtBtn} />
                                        </div>
                                        <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                                          Edit
                                        </Typography>
                                      </div>
                                    ) : null}
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          );
                        })}
                      {appDet?.appointmentStatus?.toLowerCase() !==
                      "completed" ? (
                        <div className="flex-row-ali-cen mt20">
                          <div
                            className="flex-row-ali-cen cursor"
                            onClick={addNewAdminister}
                          >
                            <div className="flex-center plus-icon">
                              <AddIcon sx={addIcon} />
                            </div>
                            <Typography className="blue-color fs16 ml5 font-bold">
                              Add
                            </Typography>
                          </div>
                          {/* <div
                        className="flex-row-ali-cen cursor ml20"
                        onClick={() => onAddFiles("administer")}
                      >
                        <div className="flex-center plus-icon">
                          <AddIcon sx={addIcon} />
                        </div>
                        <Typography className="blue-color fs16 ml5 font-bold">
                          Add From File
                        </Typography>
                      </div> */}
                          {procedValues?.adminList?.length > 0 &&
                          procedValues?.adminList?.some((li) => li?.isEdit) ? (
                            <div className="ml20">
                              <CustomButton
                                text="Save"
                                smallBtn
                                onClick={onSaveMultiAdmins}
                              />
                            </div>
                          ) : null}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              ) : null}
            </Card>
          </>
        ) : null}

        <Card sx={cardSty} className="mt20">
          <div
            className="flex-row-ali-cen cursor"
            onClick={() => handleObjOpen("pres", !objOpen?.pres)}
          >
            {objOpen?.pres ? (
              <ArrowDropDownIcon sx={cardIcon} />
            ) : (
              <ArrowRightIcon sx={cardIcon} />
            )}
            <Typography className="font-bold fs14 blue-color">
              Prescription
            </Typography>
          </div>
          {objOpen?.pres ? (
            <div style={{ overflowX: "auto", width: "100%" }} className="pb10">
              <div style={{ minWidth: 1310 }}>
                <div className="flex-row-ali-cen mh10">
                  <div style={{ width: 200 }}>
                    <Typography className="txt-semi-bold fs12 blue-color">
                      Name <span className="red-color">*</span>
                    </Typography>
                  </div>
                  {/* <div style={{ width: 170 }}>
                    <Typography className="txt-semi-bold fs12 blue-color">
                      Qty <span className="red-color">*</span>
                    </Typography>
                  </div> */}
                  <div style={{ width: 170 }}>
                    <Typography className="txt-semi-bold fs12 blue-color">
                      Dose
                    </Typography>
                  </div>
                  <div style={{ width: 150 }}>
                    <Typography className="txt-semi-bold fs12 blue-color">
                      Frequency
                    </Typography>
                  </div>
                  <div style={{ width: 150 }}>
                    <Typography className="txt-semi-bold fs12 blue-color">
                      Route
                    </Typography>
                  </div>
                  <div style={{ width: 170 }}>
                    <Typography className="txt-semi-bold fs12 blue-color">
                      Duration
                    </Typography>
                  </div>
                  <div style={{ width: 150 }}>
                    <Typography className="txt-semi-bold fs12 blue-color">
                      Instructions
                    </Typography>
                  </div>
                  <div style={{ width: 200 }}>
                    <Typography className="txt-semi-bold fs12 blue-color">
                      Remarks
                    </Typography>
                  </div>
                  <div style={{ width: 100 }} />
                </div>
                <div className="blue-hor-split mt5" />
                {procedValues?.presList?.map((pr, ind) => {
                  return (
                    <div className="flex-row mt10 plan-bor" key={`${ind}_pres`}>
                      <div className="pr10" style={{ width: 200 }}>
                        <CustomSelect
                          list={getPresList()}
                          value={pr?.plName}
                          error={pr?.nameErr}
                          helperText={pr?.nameErr ? reqTxt : ""}
                          addNewSelect
                          mandatoryField
                          handleChange={(e) => {
                            handleChangePresValue(
                              "plName",
                              e?.value ?? e,
                              pr?.i,
                              {
                                stockId: e?.stockId ?? null,
                                productId: e?.productId ?? null,
                                serviceId: e?.serviceId ?? null,
                                type: e?.type,
                              },
                            );
                          }}
                          plusBtn
                          disabled={!pr?.isEdit}
                          isForProcedure
                        />
                      </div>
                      {/* <div className="pr10" style={{ width: 170 }}>
                        <CustomTextField
                          value={pr?.qty}
                          error={pr?.qtyErr}
                          helperText={pr?.qtyErr ? reqTxt : ""}
                          handleChange={(e) => {
                            handleChangePresValue(
                              "qty",
                              e?.target?.value,
                              pr?.i,
                            );
                          }}
                          fullWidth
                          type="number"
                          endIcon
                          inputIcon={
                            <Custom3dotString
                              str={`${
                                getBatchList(pr?.stockId)?.[0]?.salesUom ?? ""
                              }`}
                              length={9}
                              className="fs12 font-medium"
                              capitalize={false}
                            />
                          }
                          disabled={!pr?.isEdit}
                        />
                      </div> */}
                      <div className="pr10" style={{ width: 170 }}>
                        <CustomTextField
                          fullWidth
                          handleChange={(e) =>
                            handleChangePresValue(
                              "dosage",
                              e?.target?.value,
                              pr?.i,
                            )
                          }
                          value={pr?.dosage}
                          disabled={!pr?.isEdit}
                          suffix={
                            getRightPackageUom(
                              getBatchList(pr?.stockId)?.[0]?.packageUom,
                              true,
                            )?.length > 0 ? (
                              <Custom3dotString
                                str={`${getRightPackageUom(
                                  getBatchList(pr?.stockId)?.[0]?.packageUom,
                                  true,
                                )}`}
                                className="fs12 font-medium"
                                length={9}
                                capitalize={false}
                              />
                            ) : (
                              ""
                            )
                          }
                        />
                      </div>
                      <div className="pr10" style={{ width: 150 }}>
                        {pr?.customFrequency ? (
                          <CustomTextField
                            fullWidth
                            handleChange={(e) =>
                              handleChangePresValue(
                                "frequency",
                                e?.target?.value,
                                pr?.i,
                              )
                            }
                            value={pr?.frequency}
                            disabled={!pr?.isEdit}
                          />
                        ) : (
                          <CustomSelect
                            list={frequncyCheckList}
                            value={pr?.frequency ?? []}
                            handleChange={(e) => {
                              handleChangePresValue(
                                "frequency",
                                e?.target?.value,
                                pr?.i,
                              );
                            }}
                            multiSelectSearchCheck
                            disabled={!pr?.isEdit}
                          />
                        )}
                      </div>
                      <div className="pr10" style={{ width: 150 }}>
                        <CustomSelect
                          list={routeList}
                          value={pr?.route}
                          search
                          handleChange={(e, value) => {
                            handleChangePresValue("route", value, pr?.i);
                          }}
                          disabled={!pr?.isEdit}
                        />
                      </div>
                      <div className="pr10" style={{ width: 170 }}>
                        <CustomTextField
                          fullWidth
                          handleChange={(e) =>
                            handleChangePresValue(
                              "duration",
                              e?.target?.value,
                              pr?.i,
                            )
                          }
                          value={pr?.duration}
                          endIcon
                          inputIcon="days"
                          disabled={!pr?.isEdit}
                        />
                      </div>
                      <div className="pr10" style={{ width: 150 }}>
                        <CustomSelect
                          list={mealTypes}
                          value={pr?.meal}
                          select
                          handleChange={(e) => {
                            handleChangePresValue(
                              "meal",
                              e?.target?.value,
                              pr?.i,
                            );
                          }}
                          disabled={!pr?.isEdit}
                        />
                      </div>
                      <div className="pr10" style={{ width: 200 }}>
                        <CustomTextField
                          value={pr?.remark}
                          handleChange={(e) => {
                            handleChangePresValue(
                              "remark",
                              e?.target?.value,
                              pr?.i,
                            );
                          }}
                          disabled={!pr?.isEdit}
                          fullWidth
                        />
                      </div>
                      <div className="flex-end" style={{ width: 100 }}>
                        {appDet?.checkOut !== "Y" ? (
                          <div className="flex-row-ali-cen mt3">
                            {/* {!pr?.isEdit ? ( */}
                            <div
                              className="cursor"
                              onClick={() => deletePresByIndex(pr?.i)}
                            >
                              <div className="flex-center">
                                <DeleteOutlineIcon sx={delBtn} />
                              </div>
                              <Typography className="red3 fs8 txt-semi-bold text-align-center">
                                Delete
                              </Typography>
                            </div>
                            {/* ) : null} */}
                            {/* {pr?.isEdit ? (
                              <div
                                className="cursor ml10"
                                onClick={() => addUpdatePresItems(pr)}
                              >
                                <div className="flex-center">
                                  <SaveIcon sx={edtBtn} />
                                </div>
                                <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                                  Save
                                </Typography>
                              </div>
                            ) : null} */}

                            {!pr?.isEdit ? (
                              <div
                                className="cursor ml10"
                                onClick={() => handleEditPresItem(pr?.i)}
                              >
                                <div className="flex-center">
                                  <EditIcon sx={edtBtn} />
                                </div>
                                <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                                  Edit
                                </Typography>
                              </div>
                            ) : null}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  );
                })}
              </div>
              {procedValues?.presNotesVisible ? (
                <div className="mt15">
                  <CustomTextField
                    fullWidth
                    value={procedValues?.notes ?? ""}
                    handleChange={(e) =>
                      onChangePresValues("notes", e?.target?.value)
                    }
                    multiline
                    placeholder="Notes"
                    disabled={!procedValues?.isNotesEdit}
                  />
                </div>
              ) : null}

              <div className="flex-row-ali-cen mt20">
                {appDet?.appointmentStatus?.toLowerCase() !== "completed" ? (
                  <>
                    <div
                      className="flex-row-ali-cen cursor"
                      onClick={handleAddNewPres}
                    >
                      <div className="flex-center plus-icon">
                        <AddIcon sx={addIcon} />
                      </div>
                      <Typography className="blue-color fs16 ml5 font-bold">
                        Add
                      </Typography>
                    </div>
                    {/* {!procedValues?.presNotesVisible ? ( */}
                    <div
                      className="flex-row-ali-cen cursor ml15"
                      onClick={() =>
                        onChangePresValues("presNotesVisible", true)
                      }
                    >
                      <div className="flex-center plus-icon">
                        <AddIcon sx={addIcon} />
                      </div>
                      <Typography className="blue-color fs16 ml5 font-bold">
                        Add Notes
                      </Typography>
                    </div>
                    {/* ) : null} */}
                    {/* <div
                      className="flex-row-ali-cen cursor ml20"
                      onClick={() => onAddFiles("pres")}
                    >
                      <div className="flex-center plus-icon">
                        <AddIcon sx={addIcon} />
                      </div>
                      <Typography className="blue-color fs16 ml5 font-bold">
                        Add From File
                      </Typography>
                    </div> */}
                  </>
                ) : null}
                {procedValues?.presList?.length > 0 ? (
                  <div className="ml20">
                    <CustomButton
                      text={
                        procedValues?.presList?.some((li) => li?.isEdit) ||
                        procedValues?.isNotesEdit
                          ? "Save"
                          : "Preview"
                      }
                      smallBtn
                      onClick={() => {
                        procedValues?.presList?.some((li) => li?.isEdit) ||
                        procedValues?.isNotesEdit
                          ? addUpdatePresItems()
                          : setPreviewModVsble(true);
                      }}
                    />
                  </div>
                ) : null}
              </div>
            </div>
          ) : null}
        </Card>
        <div className="mt20 flex-row-ali-cen">
          <Typography className="font-bold fs14 blue-color">Notes</Typography>
          {appDet?.checkOut !== "Y" ? (
            <div
              className="flex-row-ali-cen cursor flex1-end"
              onClick={onAddNotes}
            >
              <div className="flex-center plus-icon">
                <AddIcon sx={addIcon} />
              </div>
              <Typography className="blue-color fs16 ml5 font-bold">
                Add
              </Typography>
            </div>
          ) : null}
        </div>
        <Typography
          className="mt5 mb10 font-medium fs12 black"
          style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
          component="div"
        >
          {appDet?.notes?.split("\n")?.map((line, index) => (
            <div key={index}>{line || "\u00A0"}</div>
          ))}
        </Typography>
      </div>

      <CustomModal
        open={conStatusVsble}
        onClose={onCloseConMod}
        header="Reason"
        modal
        modalWidth={30}
        headerShown={true}
      >
        <div className="ph10">
          <CustomSelect
            list={reasonList}
            value={consumValues?.reason}
            select
            handleChange={(e) =>
              onChangeConStatusValue("reason", e?.target?.value)
            }
          />
        </div>
        <div className="flex-center">
          <div className="w20Per mv20">
            <CustomButton
              text="Save"
              smallBtn
              onClick={handleSaveConsumStatus}
            />
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={admStatusVsble}
        onClose={onCloseAdmMod}
        header="Reason"
        modal
        modalWidth={30}
        headerShown={true}
      >
        <div className="ph10">
          <CustomSelect
            list={reasonList}
            value={adminValues?.reason}
            select
            handleChange={(e) =>
              onChangeAdminStatusValue("reason", e?.target?.value)
            }
          />
        </div>
        <div className="flex-center">
          <div className="w20Per mv20">
            <CustomButton
              text="Save"
              smallBtn
              onClick={handleSaveAdminStatus}
            />
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={notesModVsble}
        onClose={onCloseNoteMod}
        header="Notes"
        modal
        modalWidth={40}
        headerShown={true}
      >
        <div className="ph10">
          <CustomTextField
            value={notes}
            handleChange={(e) => setNotes(e?.target?.value)}
            multiline
            rows={4}
            fullWidth
          />
        </div>
        <div className="flex-center">
          <div className="w20Per mv20">
            <CustomButton text="Save" smallBtn onClick={onSaveNotes} />
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={admUpdteModVsble}
        onClose={onCloseAdmUpdteMod}
        header="Administer"
        rightModal
        modalWidth={30}
      >
        <div className="ph20 scroll-80vh">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">Name</div>
              <CustomSelect
                list={
                  adminValues?.fromService
                    ? getDropList(adminValues)
                    : getList(true)
                }
                value={adminValues?.name}
                addNewSelect
                mandatoryField
                handleChange={(e) => {
                  onChangeAdminModValue("name", e?.value ?? e, {
                    stockId: e?.stockId ?? null,
                    productId: e?.productId ?? null,
                    serviceId: e?.serviceId ?? null,
                    type: e?.type,
                  });
                }}
                plusBtn
                isForProcedure
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">Batch Number</div>
              <CustomSelect
                list={getBatches(adminValues?.stockId)}
                value={adminValues?.batchNumber}
                handleChange={(e, value) => {
                  onChangeAdminModValue("batchNumber", value);
                }}
                search
                isBatchNumber
                disabled={
                  getBatch(adminValues?.stockId, null, true)?.autoConsumed
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">Dosage</div>
              <CustomTextField
                fullWidth
                handleChange={(e) =>
                  onChangeAdminModValue("dosage", e?.target?.value)
                }
                value={adminValues?.dosage}
                suffix={
                  getRightPackageUom(
                    getBatch(
                      adminValues?.stockId,
                      adminValues?.batchNumber?.value ?? adminValues?.batchId,
                    )?.packageUom,
                  )?.length > 0 ? (
                    <Custom3dotString
                      str={`${getRightPackageUom(
                        getBatch(
                          adminValues?.stockId,
                          adminValues?.batchNumber?.value ??
                            adminValues?.batchId,
                        )?.packageUom,
                      )}`}
                      length={9}
                      className="fs12 font-medium"
                    />
                  ) : (
                    ""
                  )
                }
                type="number"
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">Route</div>
              <CustomSelect
                list={routeList}
                value={adminValues?.route}
                search
                handleChange={(e, value) => {
                  onChangeAdminModValue("route", value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">
                Link to Procedure
              </div>
              <CustomSelect
                list={getProcedureListAsDrop()}
                value={adminValues?.linkToProcedure}
                select
                handleChange={(e) => {
                  const reqPrcd = getProcedureListAsDrop()?.find(
                    (li) => li?.name === e?.target?.value,
                  );
                  onChangeAdminModValue("linkToProcedure", e?.target?.value, {
                    serviceId: reqPrcd?.serviceId,
                    variantId: reqPrcd?.variantId,
                  });
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-row-ali-cen">
                <div className="txt-semi-bold fs14 light-grey">Status </div>
                {typeof adminValues?.status === "boolean" ? (
                  <Typography
                    className={`${
                      adminValues?.status ? "green-back5" : "red-back2"
                    } white-color status-con fs12 font-medium ml15`}
                  >
                    {adminValues?.status ? "Completed" : "Not Done"}
                  </Typography>
                ) : null}
              </div>
              <div className="mt5">
                <CustomSelect
                  list={statusDrop}
                  value={adminValues?.statusDrop}
                  select
                  handleChange={(e) =>
                    onChangeAdminModValue("statusDrop", e?.target?.value)
                  }
                />
              </div>
              {/* <div className="flex-row-ali-cen mt15">
                <img
                  src={require("../../../../assets/images/png/tick.png")}
                  className="img-wh20 cursor"
                  onClick={() => onChangeAdminModValue("status", true)}
                />
                <img
                  src={require("../../../../assets/images/png/crossRed.png")}
                  className="img-wh20 ml30 cursor"
                  onClick={() => onChangeAdminModValue("status", false)}
                />
              </div> */}
            </Grid>
            {typeof adminValues?.status === "boolean" &&
            !adminValues?.status ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="txt-semi-bold fs14 light-grey">Reason</div>
                <CustomSelect
                  list={reasonList}
                  value={adminValues?.reason}
                  select
                  handleChange={(e) =>
                    onChangeAdminModValue("reason", e?.target?.value)
                  }
                />
              </Grid>
            ) : null}

            {adminValues?.status ? (
              adminValues?.type?.toLowerCase() === "flea & tick treatment" ||
              adminValues?.type?.toLowerCase() === "vaccines" ||
              adminValues?.type?.toLowerCase() === "deworming" ? (
                <>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    {adminValues?.files?.length > 0 ? (
                      <FilesWithCloseButton
                        files={adminValues?.files}
                        onClickFile={(i, file) => handleAdmImageRemove(i)}
                      />
                    ) : null}
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <CustomUpload
                      onUploadFile={onUploadAdmFile}
                      multipleNew
                      multiFiles
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className="txt-semi-bold fs14 light-grey">
                      Schedule for the next dosage?
                    </div>
                    <CustomCheckbox
                      radio
                      name="nextDosage"
                      onChange={(e) =>
                        onChangeAdminModValue("nextDosage", e?.target?.value)
                      }
                      radios={radioYesNoList}
                      defaultValue={adminValues?.nextDosage ?? "No"}
                    />
                  </Grid>
                  {adminValues?.nextDosage === "Yes" ? (
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="mtMin15"
                    >
                      <div className="txt-semi-bold fs14 light-grey">
                        Next Due Date
                      </div>
                      <CustomTextField
                        name="nextDueDate"
                        fullWidth
                        handleChange={(e) =>
                          onChangeAdminModValue("nextDueDate", e?.target?.value)
                        }
                        value={adminValues?.nextDueDate ?? datePlusOneDay}
                        mobileDate
                        minDate={datePlusOneDay}
                      />
                    </Grid>
                  ) : null}
                </>
              ) : null
            ) : null}
          </Grid>

          <div className="flex-center">
            <div className="w20Per mv20">
              <CustomButton text="Save" smallBtn onClick={onSaveAdminValues} />
            </div>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={fileValues?.modVsble}
        onClose={onCloseFileMod}
        header="Files"
        modal
        modalWidth={40}
      >
        <div className="ph20 scroll-50vh">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              {fileValues?.files?.length > 0 ? (
                <FilesWithCloseButton
                  files={fileValues?.files}
                  onClickFile={(i, file) => handleRemoveFile(i)}
                />
              ) : null}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomUpload
                onUploadFile={onUploadFiles}
                multipleNew
                multiFiles
                fileAccept="image/*,.pdf"
              />
            </Grid>
          </Grid>

          <div className="flex-center">
            <div className="w20Per mv20">
              <CustomButton text="Upload" smallBtn onClick={onFilesApiCall} />
            </div>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={changeWarnVsble}
        onClose={onCloseChangeWarnMod}
        header=""
        modal
        modalWidth={30}
        headerShown={false}
      >
        <div className="flex-row">
          <Typography className="txt-semi-bold fs16 text-align-center mv20 orange4">
            All changes will be lost. Are you sure you want to continue?
          </Typography>
        </div>
        <div className="flex-row-ali-cen flex-center pb20">
          <div>
            <CustomButton
              text="Yes"
              redBtn
              smallBtn
              onClick={onConfirmChangeWarn}
            />
          </div>
          <div className="ml20">
            <CustomButton text="No" smallBtn onClick={onCloseChangeWarnMod} />
          </div>
        </div>
      </CustomModal>
      <CustomModal
        open={delModVsble}
        onClose={onCloseDelMod}
        header=""
        modal
        modalWidth={30}
        headerShown={false}
      >
        <div className="flex-center">
          <Typography className="txt-semi-bold fs16 text-align-center mv20 orange4">
            Are you sure you want to delete this record?
          </Typography>
        </div>
        <div className="flex-row-ali-cen flex-center pb20">
          <div>
            <CustomButton
              text="Yes"
              redBtn
              smallBtn
              onClick={onConfirmDelete}
            />
          </div>
          <div className="ml20">
            <CustomButton text="No" smallBtn onClick={onCloseDelMod} />
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={previewModVsble}
        onClose={() => setPreviewModVsble(false)}
        header=""
        // "Prescription"
        headerCenter
        modal
        headerBold
        modalWidth={80}
      >
        <div className="scroll-80vh">
          <ContentToPrint
            ref={contentToPrint}
            // sign={
            //   <div className="mb10 flex1-end w100Per">
            //     <div>
            //       <div className="txt-semi-bold fs12 black">
            //         {`${getRightSaluation(clinicVets, appDet?.doctorId)}${
            //           appDet?.doctorName ?? ""
            //         }`}
            //       </div>
            //       <div className="font-medium fs12 black">
            //         Signature of Veterinarian
            //       </div>
            //     </div>
            //   </div>
            // }
            footer={
              <div className="prescription-print-footer-inner">
                <div className="mb20 flex-start prescription-print-footer-doctor-row">
                  <div>
                    <div className="txt-semi-bold fs12 black">
                      Clinician Signature
                    </div>
                    {/* <div className="prescription-print-footer-doctor-name txt-semi-bold fs12 black">
                      {`Dr. ${appDet?.doctorName ?? ""}`}
                    </div> */}
                    {/* <div className="font-medium fs12 black">
                      Signature of Veterinarian
                    </div> */}
                  </div>
                </div>
                {appDet?.appointmentType === "Virtual" ? (
                  <div className="flex-center prescription-print-footer-disclaimer">
                    <div className="flex-row-ali-cen">
                      <div className="font-bold fs12 black">
                        Telemedicine Disclaimer:
                      </div>
                      <div className="txt-regular fs12 black ml10">
                        This prescription has been generated through
                        telemedicine consultation.
                      </div>
                    </div>
                  </div>
                ) : null}
                {clinicDet?.footer?.length > 0 ? (
                  <img src={clinicDet?.footer} alt="" />
                ) : null}
              </div>
            }
            header={
              <div className="flex-row-ali-cen mv20">
                <div className="w35Per">
                  <div>
                    {clinicDet?.image ? (
                      <img src={clinicDet?.image} className="img-h75" alt="" />
                    ) : (
                      <div className="flex-center h50img">
                        <Typography className="font-bold fs30 white-color capitalize">
                          {clinicDet?.name?.[0]}
                        </Typography>
                      </div>
                    )}
                  </div>
                </div>
                <div className="w30Per flex-center">
                  <div className="font-bold fs20 blue-color">Prescription</div>
                </div>
                <div className="w35Per flex1-end">
                  <div className="prescription-doc-header-clinic">
                    {/* <div className="font-bold fs12 blue-color">
                      Business Name:
                    </div> */}
                    <div className="font-bold blue-color fs16">
                      {clinicDet?.name ?? ""}
                    </div>
                    {/* <div className="font-bold fs12 blue-color mt5">
                      Business Address:
                    </div> */}
                    <div className="txt-regular fs12 blue-color">
                      {clinicDet?.address ?? ""}
                    </div>
                    {clinicDet?.taxId?.length > 0 ? (
                      <div className="flex-row-ali-cen mt5">
                        <div className="font-bold fs12 blue-color">
                          {/* CLINIC  */}
                          TAX ID:{" "}
                        </div>
                        <div className="txt-regular fs12 blue-color ml3">
                          {clinicDet?.taxId ?? ""}
                        </div>
                      </div>
                    ) : null}
                    {clinicDet?.mobile?.length > 0 ? (
                      <div className="flex-row-ali-cen mt5">
                        <div className="font-bold fs12 blue-color">
                          Contact:{" "}
                        </div>
                        <div className="txt-regular fs12 blue-color ml3">
                          {clinicDet?.mobile ?? ""}
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            }
          >
            <tr>
              <td className="prescription-print-tbody-cell">
                <div className="prescription-print-body-inner">
                  {/* <div className="prescription-print-top-block">
                    <div className="flex-center mb20 font-bold blue-color fs18 prescription-print-hide-in-pdf">
                      Prescription
                    </div>

                    <div className="flex-end mb10">
                      <img alt="" src={clinicDet?.image} className="img-h50" />
                    </div>
                  </div> */}

                  <div className="p5">
                    <div
                    // className="blue-box-examD"
                    >
                      <div className="flex-row prescription-print-patient-block">
                        <div className="w65Per">
                          <div className="flex-column">
                            <div className="flex-row mv5">
                              {appDet?.petType?.length > 0 ? (
                                <>
                                  <div className="font-bold fs12 blue-color">
                                    Pet Name:
                                  </div>
                                  <div className="font-bold fs12 black capitalize ml5">
                                    {appDet?.petName}
                                  </div>
                                </>
                              ) : null}
                              {appDet?.petType?.length > 0 ? (
                                <>
                                  <div className="font-bold fs12 blue-color ml15">
                                    Species:
                                  </div>
                                  <div className="txt-regular fs12 black capitalize ml5">
                                    {appDet?.petType}
                                  </div>
                                </>
                              ) : null}
                              {appDet?.breed?.length > 0 ? (
                                <>
                                  <div
                                    className={`font-bold fs12 blue-color ${appDet?.petType?.length > 0 ? "ml15" : ""}`}
                                  >
                                    Breed:
                                  </div>
                                  <div className="txt-regular fs12 black capitalize ml5">
                                    {appDet?.breed}
                                  </div>
                                </>
                              ) : null}
                            </div>
                            <div className="flex-row mv5">
                              {genderEnum?.[appDet?.gender]?.length > 0 ? (
                                <>
                                  <div className="font-bold fs12 blue-color">
                                    Gender:
                                  </div>
                                  <div className="txt-regular fs12 black capitalize ml5">
                                    {genderEnum?.[appDet?.gender]}
                                  </div>
                                </>
                              ) : null}
                              {appDet?.weight?.length > 0 ? (
                                <>
                                  <div
                                    className={`font-bold fs12 blue-color ${genderEnum?.[appDet?.gender]?.length > 0 ? "ml15" : ""}`}
                                  >
                                    Weight:
                                  </div>
                                  <div className="txt-regular fs12 black capitalize ml5">
                                    {appDet?.weight} Kg
                                  </div>
                                </>
                              ) : null}
                              {appDet?.dob?.length > 0 ? (
                                <>
                                  <div
                                    className={`font-bold fs12 blue-color ${genderEnum?.[appDet?.gender]?.length > 0 ? "ml15" : ""}`}
                                  >
                                    Age:
                                  </div>
                                  <div className="txt-regular fs12 black capitalize ml5">
                                    {moment(new Date(appDet?.dob))?.fromNow(
                                      true,
                                    )}
                                  </div>
                                </>
                              ) : null}
                            </div>
                            <div className="flex-row mv5">
                              <div className="font-bold fs12 blue-color">
                                Customer:
                              </div>
                              <div className="font-bold fs12 black capitalize ml5">
                                {appDet?.userName}
                              </div>
                            </div>
                            {appDet?.address?.length > 0 ? (
                              <div className="flex-row mv5">
                                <div className="w40Per">
                                  <div className="font-bold fs12 blue-color">
                                    Address:
                                  </div>
                                  <div className="txt-regular fs12 black capitalize ml5">
                                    {appDet?.address}
                                  </div>
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </div>
                        <div className="w35Per">
                          <div className="flex-column">
                            <div className="flex-row mt10">
                              <div className="font-bold fs12 blue-color">
                                Vet Name:
                              </div>
                              <div className="font-bold fs12 black ml5 capitalize">
                                {`${getRightSaluation(clinicVets, appDet?.doctorId)}${
                                  appDet?.doctorName ?? ""
                                }`}
                              </div>
                              {appDet?.registrationNo?.length > 0 ? (
                                <div className="flex-row-ali-cen">
                                  <div className="font-regular fs12 black ml5">
                                    (
                                  </div>
                                  <div className="font-bold fs12 blue-color ml2">
                                    RegNo:
                                  </div>
                                  <div className="font-regular fs12 black ml5 capitalize">
                                    {appDet?.registrationNo} )
                                  </div>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="flex-row mv5">
                              <div className="font-bold fs12 blue-color">
                                Date:
                              </div>
                              <div className="txt-regular fs12 black ml5">
                                {moment(
                                  new Date(appDet?.appointmentDate),
                                ).format("DD MMM YYYY")}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="box-hor-split mv10" />
                      <PrescriptionView prescriptions={reqDet?.presList} />
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </ContentToPrint>
          <div className="flex1-end mv20">
            <div>
              <CustomButton text="Print" onClick={handlePrint} smallBtn />
            </div>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={addProcedModVsble}
        onClose={onCloseAddProcedMod}
        header="Add"
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh ph20 mt10">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="red-back4 br5 ph20 pv10 flex-row-between-align-center">
                <Typography className="red14 fs14 txt-semi-bold">
                  Cost
                </Typography>
                <Typography className="red14 fs14 txt-semi-bold">
                  Rs.{" "}
                  {Number(selectedProcedure?.variant?.serviceCharge)?.toFixed(
                    2,
                  )}
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="font-medium fs14">
                Procedure Name <span className="red-color">*</span>
              </Typography>
              <CustomSelect
                value={selectedProcedure?.service?.name ?? ""}
                selectFixed
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="font-medium fs14">
                Variant <span className="red-color">*</span>
              </Typography>
              <CustomSelect
                value={selectedProcedure?.variant?.name ?? ""}
                selectFixed
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomTextField
                label="Next Due Date"
                labelTop
                fullWidth
                value={addNewProcedValues?.nextDueDate}
                handleChange={(e) =>
                  setAddNewProcedValues({
                    ...addNewProcedValues,
                    nextDueDate: e?.target?.value,
                  })
                }
                mobileDate
                mandatoryField
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="font-medium fs14">Remarks</Typography>
              <CustomTextField
                fullWidth
                handleChange={(e) =>
                  setAddNewProcedValues({
                    ...addNewProcedValues,
                    remarks: e?.target?.value,
                  })
                }
                value={addNewProcedValues?.remarks}
                multiline
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-end">
                <div>
                  <CustomButton
                    text="Save"
                    smallBtn
                    onClick={handleSaveReminderProcedure}
                  />
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </CustomModal>
    </>
  );
};

export default PetProcedures;
